var _currentOnlineStoreStock = null;
var _currentOnlineStoreStockMax = null;
var _currentPickStoreStock = null;

function getSelectedStockStoreID() {
    const storeID = String(
        window.ShopifyTranslations?.selectStoreOID ||
        localStorage.getItem("storeOID") ||
        window.ShopifyTranslations?.selectStoreID ||
        localStorage.getItem("storeID") ||
        ""
    );
    return storeID === "0" ? "" : storeID;
}
 
// ─── DELIVERY DATE/TIME TEST OVERRIDE ────────────────────────────────────────
window.DELIVERY_TEST_NOW = null;
// To test, set in console:  window.DELIVERY_TEST_NOW = new Date("2026-06-29T00:00:00");renderPdpDeliveryMessage();
// ─────────────────────────────────────────────────────────────────────────────
 
function getProductPalletType() {
    const input = document.querySelector(
        '.product-block-product-form input[name="properties[_pallettype]"]'
    );
    return input ? input.value.trim().toUpperCase() : "";
}
 
function getAtpSkipExtra() {
    const input = document.querySelector(
        '.product-block-product-form input[name="atpskipextra"]'
    );
    if (!input) return true;
    const val = input.value.trim().toLowerCase();
    return val === "yes" || val === "true" || val === "1";
}
 
function getShippingDeliveryRule() {
    try {
        const rawRule = window.ShopifyTranslations?.shippingDeliveryRule || "{}";
        return typeof rawRule === "string" ? JSON.parse(rawRule) : rawRule;
    } catch (e) {
        return {};
    }
}
 
/**
 * Reads the cutoff hour for a given product type (BM/DC) from the
 * shippingDeliveryRule config's "cutoff_hours" key, e.g.:
 *   { "cutoff_hours": { "BM": 13, "DC": 19 } }
 * Falls back to the original hardcoded defaults (BM=13, DC=19) if
 * not configured or if the configured value isn't a valid hour (0–23).
 */
function getCutoffHour(type) {
    const DEFAULTS = { BM: 13, DC: 19 };
    const rule = getShippingDeliveryRule();
    const configured = rule?.cutoff_hours?.[type];
    const hour = parseInt(configured, 10);
 
    if (!isNaN(hour) && hour >= 0 && hour <= 23) {
        return hour;
    }
    return DEFAULTS[type] ?? 13;
}
 
function formatDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
 
function isDeliveryHoliday(date) {
    // Sunday default holiday
    if (date.getDay() === 0) {
        console.log(`  [isDeliveryHoliday] ${formatDateKey(date)} → Sunday (default holiday)`);
        return true;
    }
 
    const rule = getShippingDeliveryRule();
    const holidays = Array.isArray(rule.holidays) ? rule.holidays : [];
    const dateKey = formatDateKey(date);
 
    const match = holidays.find(holiday => holiday.date === dateKey);
    if (match) {
        console.log(`  [isDeliveryHoliday] ${dateKey} → configured holiday: "${match.name || '(no name)'}"`);
        return true;
    }
    return false;
}
 
function isDeliveryHolidayForType(date, type) {
    if (isDeliveryHoliday(date)) return true; // Sunday + configured holidays
    const day = date.getDay(); // 0=Sun,1=Mon,6=Sat
    if (type === "BM" && day === 6) {
        console.log(`  [isDeliveryHolidayForType] ${formatDateKey(date)} → Saturday blocked for BM`);
        return true;
    }
    if (type === "DC" && day === 1) {
        console.log(`  [isDeliveryHolidayForType] ${formatDateKey(date)} → Monday blocked for DC`);
        return true;
    }
    return false;
}
 
/**
 * Returns true if calendar-tomorrow is a valid (non-blocked) delivery day
 * for this product type. Used to decide whether the "delivered tomorrow"
 * wording is accurate, or whether we need the exact-date template instead.
 */
function isNextCalendarDayValidForType(type) {
    const tomorrow = window.DELIVERY_TEST_NOW ? new Date(window.DELIVERY_TEST_NOW) : new Date(); // ← TEST OVERRIDE
    tomorrow.setDate(tomorrow.getDate() + 1);
    const valid = !isDeliveryHolidayForType(tomorrow, type);
    console.log(`[isNextCalendarDayValidForType] type=${type} tomorrow=${formatDateKey(tomorrow)} → valid=${valid}`);
    return valid;
}
 
/**
 * Advance `eligibleDays` calendar days from today, then keep nudging
 * forward until the final date is not a holiday for this product type.
 */
function formatDeliveryDateForType(eligibleDays, type) {
    console.log(`[formatDeliveryDateForType] type=${type} eligibleDays=${eligibleDays} — walking forward...`);
    const date = window.DELIVERY_TEST_NOW ? new Date(window.DELIVERY_TEST_NOW) : new Date(); // ← TEST OVERRIDE
    let added = 0;
 
    while (added < eligibleDays) {
        date.setDate(date.getDate() + 1);
 
        // Count only valid delivery days for this product type
        if (!isDeliveryHolidayForType(date, type)) {
            added++;
            console.log(`  [formatDeliveryDateForType] ${formatDateKey(date)} → eligible (added=${added}/${eligibleDays})`);
        } else {
            console.log(`  [formatDeliveryDateForType] ${formatDateKey(date)} → SKIPPED (blocked)`);
        }
    }
 
    // Final delivery date must also respect BM/DC-specific blocked days
    // (handles edge case if eligibleDays = 0)
    while (isDeliveryHolidayForType(date, type)) {
        console.log(`  [formatDeliveryDateForType] landing date ${formatDateKey(date)} is blocked — nudging forward`);
        date.setDate(date.getDate() + 1);
    }
 
    const formatted = date.toLocaleDateString("nl-NL", {
        weekday: "long",
        month: "long",
        day: "numeric"
    });
    console.log(`[formatDeliveryDateForType] FINAL → ${formatDateKey(date)} (${formatted})`);
    return formatted;
}
 
function advanceEligibleDays(startDate, eligibleDays) {
    const date = new Date(startDate);
    let added = 0;
    while (added < eligibleDays) {
        date.setDate(date.getDate() + 1);
        if (!isDeliveryHoliday(date)) added++;
    }
    return date;
}
 
function formatDeliveryDate(eligibleDays) {
    const date = advanceEligibleDays(new Date(), eligibleDays);
    return date.toLocaleDateString("nl-NL", {
        weekday: "long",
        month: "long",
        day: "numeric"
    });
}
 
function getDeliveryMessage(productType, currentQty) {
    const type = (productType || "").toString().trim().toUpperCase();
    console.group(`[getDeliveryMessage] type=${type} currentQty=${currentQty}`);
 
    if (type !== "DC" && type !== "BM") {
        console.log("→ not BM/DC, returning empty string");
        console.groupEnd();
        return "";
    }
 
    const t = window.ShopifyTranslations || {};
    const skipExtra = getAtpSkipExtra();
    const cutoffHour = getCutoffHour(type);
    const now = window.DELIVERY_TEST_NOW ? new Date(window.DELIVERY_TEST_NOW) : new Date(); // ← TEST OVERRIDE
    const isBeforeCutoff = now.getHours() < cutoffHour;
    const cutoffTimeStr = `${String(cutoffHour).padStart(2, "0")}:00`;
 
    // Saturday = day 6, Sunday = day 0
    const todayIsWeekend = now.getDay() === 0 || now.getDay() === 6;
    const todayIsBlocked = isDeliveryHolidayForType(now, type);
 
    const replaceDate = (msg, dateStr, timeStr) =>
        (msg || "")
            .replace("[date]", dateStr)
            .replace("{date}", dateStr)
            .replace("[time]", timeStr)
            .replace("{time}", timeStr);
 
    // ── Determine exceedsMax (only relevant when skipExtra = No)
    let exceedsMax = false;
    let qty = null, maxQty = null;
    if (!skipExtra) {
        qty    = parseInt(currentQty, 10) || 0;
        maxQty = parseInt(_currentOnlineStoreStockMax, 10) || 0;
        // maxQty === 0 means no ceiling configured → always treat as exceeds max (+3 days)
        // maxQty > 0 and qty exceeds it → also +3 days
        exceedsMax = maxQty === 0 || qty > maxQty;
        console.log(`qty=${qty}, maxQty(_currentOnlineStoreStockMax)=${maxQty}, exceedsMax=${exceedsMax}`);
    } else {
        console.log("skipExtra=true → qty/maxQty check skipped entirely");
    }
 
    // ── totalDays: eligible-day count to walk forward from today.
    //
    // BM blocks Saturday + Sunday.
    // On a BM-blocked day (Sat/Sun), today can't be processed regardless of
    // the clock → always use after-cutoff counts (2/4) so the walk lands
    // on Tuesday instead of Monday.
    //
    // DC blocks Sunday + Monday.
    // DC Saturday is NOT blocked, but after cutoff on Saturday the next DC
    // eligible day is Tuesday (Mon is blocked), so only 1 eligible day is
    // needed — same as before-cutoff. Sunday is universally blocked; Monday
    // is DC-blocked. Both land on Tuesday with 1 eligible day.
    // Only Mon after cutoff genuinely needs 2 (→ Wednesday).
    // Rule: for DC, weekend days (Sat/Sun) always use before-cutoff counts
    // (1/3); Mon and normal weekdays use the clock-based cutoff as usual.
    //
    // Confirmed totalDays table (eligible-day count, normal flow exceedsMax=false):
    //   BM, normal weekday, before cutoff  → 1
    //   BM, normal weekday, after  cutoff  → 2
    //   BM, Sat or Sun (any time)          → 2   ← blocked, skip extra day
    //   DC, normal weekday, before cutoff  → 1
    //   DC, normal weekday, after  cutoff  → 2
    //   DC, Sat or Sun (any time)          → 1   ← weekend, Mon is also skipped by walk
    //   DC, Mon, before cutoff             → 1
    //   DC, Mon, after  cutoff             → 2
    let totalDays;
    if (type === "BM") {
        // Blocked day (Sat/Sun) → always 2; else normal cutoff logic
        if (!todayIsBlocked && isBeforeCutoff) {
            totalDays = exceedsMax ? 3 : 1;
        } else {
            totalDays = exceedsMax ? 4 : 2;
        }
    } else {
        // DC: weekend (Sun/Mon) → always 1; else normal cutoff logic
        if (isBeforeCutoff || todayIsWeekend) {
            totalDays = exceedsMax ? 3 : 1;
        } else {
            totalDays = exceedsMax ? 4 : 2;
        }
    }
    console.log(`totalDays = ${totalDays} (isBeforeCutoff=${isBeforeCutoff}, todayIsWeekend=${todayIsWeekend}, todayIsBlocked=${todayIsBlocked}, exceedsMax=${exceedsMax})`);
 
    const deliveryDate = formatDeliveryDateForType(totalDays, type);
 
    // "Tomorrow" wording is valid only when:
    // - today is not a weekend day (Sat/Sun) — weekends never promise next-day delivery
    // - it is before cutoff
    // - not exceedsMax
    // - and calendar-tomorrow is itself a non-blocked day for this type
    //
    // Note: DC Monday before cutoff IS eligible for "tomorrow" wording because
    // tomorrow (Tuesday) is a valid DC delivery day. todayIsBlocked is true for
    // Monday, but we only suppress on weekends, not on type-specific blocked days.
    const canUseTomorrowWording =
        !todayIsWeekend && isBeforeCutoff && !exceedsMax && isNextCalendarDayValidForType(type);
    console.log(`canUseTomorrowWording = ${canUseTomorrowWording}`);
 
    let template, templateKey;
    if (isBeforeCutoff) {
        if (canUseTomorrowWording) {
            templateKey = type === "DC" ? "deliveryMsgDcBeforeCutoff" : "deliveryMsgBmBeforeCutoff";
        } else {
            templateKey = type === "DC" ? "deliveryMsgDcNoSkipBeforeCutoff" : "deliveryMsgBmNoSkipBeforeCutoff";
        }
    } else {
        templateKey = type === "DC" ? "deliveryMsgDcAfterCutoff" : "deliveryMsgBmAfterCutoff";
    }
    template = t[templateKey] || "";
    console.log(`templateKey = "${templateKey}" → "${template}"`);
 
    const result = replaceDate(template, deliveryDate, cutoffTimeStr);
    console.log(`FINAL MESSAGE → "${result}"`);
    console.groupEnd();
    return result;
}
 
/**
 * Render the delivery message into the PDP delivery + pickup cards.
 * Targets the rendered classes:
 *   .js-card-delivery-msg__delivery
 *   .js-card-delivery-msg__pickup-store
 * If you only want it on the delivery card, remove the pickup target below.
 */
function renderPdpDeliveryMessage(
    pickStoreStock = null,
    onlineStoreStock = null,
    onlineStoreStockMax = null
){
    const deliveryTarget = document.querySelector(".js-card-delivery-msg__delivery");
    const pickupTarget   = document.querySelector(".js-card-delivery-msg__pickup-store");
 
    if (!deliveryTarget && !pickupTarget) return;
 
    // Read current PDP qty to decide which delivery rule to use
    const pdpQtyInput = document.querySelector(
        '.product-block-product-form .quantity-input-field'
    );
    const currentQty = pdpQtyInput ? parseInt(pdpQtyInput.value, 10) || 1 : 1;
 
    const deliveryMsg = getDeliveryMessage(getProductPalletType(), currentQty);
 
    // DELIVERY MESSAGE
    if (deliveryTarget) {
        const onlineStockToUse = onlineStoreStock !== null
            ? parseInt(onlineStoreStock, 10)
            : parseInt(_currentOnlineStoreStock, 10);
 
        if (onlineStockToUse > 0) {
            deliveryTarget.textContent = deliveryMsg;
            deliveryTarget.style.display = deliveryMsg ? "" : "none";
        } else {
            deliveryTarget.textContent = "";
            deliveryTarget.style.display = "none";
        }
    }
 
    // PICKUP MESSAGE
    if (pickupTarget) {
        const stockToUse = pickStoreStock !== null
            ? parseInt(pickStoreStock, 10)
            : parseInt(_currentPickStoreStock, 10);
 
        // Only show message if pickup stock > 0
        if (stockToUse > 0) {
            pickupTarget.textContent = window.ShopifyTranslations?.pickupAvailableImmediately || "";
            pickupTarget.style.display = "";
        } else {
            pickupTarget.textContent = "";
            pickupTarget.style.display = "none";
        }
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    document.addEventListener("store:selected", async function(event) {
        const store = event.detail?.store;

        if (window.ShopifyTranslations && store) {
            window.ShopifyTranslations.selectStoreID = parseInt(store.locationId || store.storeID || 0, 10) || 0;
            window.ShopifyTranslations.selectStoreOID = String(store.storeOid || store.storeOID || store.locationId || store.storeID || "");
            window.ShopifyTranslations.selectStoreName = store.locationName || store.storeName || "";
        }

        updateCartSelectedStoreUI(store);

        const updatedCartItems = document.querySelectorAll(".cart-item");
        if (updatedCartItems.length > 0) {
            await cartProductInventoryAPI();
        }

        // recompute mini-cart caps for the new store's pickup stock (cache-only)
        applyMiniCartQuantityMax();

        // Update PDP inventory when a new store is selected
        const productDetails = document.querySelector(".product-block-product-form");
        if (productDetails) {
            const skuElement = document.querySelector(".product-main-sku > span");
            if (skuElement && !skuElement.closest(".visually-hide")) {
                let productSku = skuElement.textContent.trim();
                if (/^[0-9]+$/.test(productSku)) {
                    productSku = productSku.padStart(10, '0');
                    await productInventoryApi(productSku);

                    // Also update shelf location for the new store
                    const productIdElement = document.querySelector(".product-main-sku");
                    let asposProductID = "";
                    if (productIdElement && !productIdElement.closest(".visually-hide")) {
                        asposProductID = productIdElement?.dataset?.asposproductid || "";
                    }
                    await productShelfLocationAPI(productSku, asposProductID);
                }
            }

            // Re-render delivery message in case the cards were repainted
            renderPdpDeliveryMessage();
        }

        // ── FIX: Show loader while re-running inventory for ALL product cards
        // on the page (collection grid, search results, recommendation carousels)
        // after a store is selected. Clears inventory-loaded flag so inventoryAPI()
        // reprocesses them with the newly selected store's pickup stock.
        const allProductCards = document.querySelectorAll(".card-product");
        if (allProductCards.length > 0) {
            showPageLoader();
            try {
                allProductCards.forEach(card => card.classList.remove("inventory-loaded"));
                await inventoryAPI();
            } finally {
                hidePageLoader();
            }
        }

        // Re-run compare inventory if on the compare page
        const productCompare = document.querySelector("product-compare");
        if (productCompare) {
            await compareInventoryAPI();
        }
    });

    // ── FIX: Show loader on collection/search pages while stock pills are
    // being fetched and rendered. Covers the initial page load case where
    // cards render with placeholder "no-stock" state until the API responds.
    const productCards = document.querySelectorAll(".card-product");
    if(productCards.length > 0) {
        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';
        showPageLoader();
        try {
            await inventoryAPI();
            await kluslistProductCardAPI(cid);
        } finally {
            hidePageLoader();
        }
    }

    // Compare page - wait for all columns to render before fetching stock
    const productCompare = document.querySelector("product-compare");
    if (productCompare) {
        await waitForCompare();
        await compareInventoryAPI();
    }

    const productDetails = document.querySelector(".product-block-product-form");
    if(productDetails) {
        const skuElement = document.querySelector(".product-main-sku > span");
        let productSku = "";
        // Check if element exists and is visible
        if (skuElement && !skuElement.closest(".visually-hide")) {
            productSku = skuElement.textContent.trim();
        }

        if (/^[0-9]+$/.test(productSku)) {
            productSku = productSku.padStart(10, '0');
            await productInventoryApi(productSku);
        }

        // Render the delivery message based on product pallet type + current time
        renderPdpDeliveryMessage();
    }

    const cartProductCards = document.querySelectorAll(".cart-item");
    if(cartProductCards.length > 0) {
        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';
        updateCartSelectedStoreUI();
        await cartProductInventoryAPI();
        await kluslistCartProductCardAPI("desktop", cid);
        await kluslistCartProductCardAPI("mobile", cid);
    }

    // Fetch Product Shelf Location
    const productDetailsSection = document.querySelector(".product-block-product-form");
    if(productDetailsSection) {
        const skuElement = document.querySelector(".product-main-sku > span");
        let productSku = ""; // Product Number in Aspos (with leading 0's to maintain 10 digit patterns) | SKU in Shopify
        let asposProductID = ""; //Variant Product Specification picking the ASPOS Product ID from there
        const productIdElement = document.querySelector(".product-main-sku");
        if(productIdElement && !productIdElement.closest(".visually-hide")) {
            asposProductID = productIdElement?.dataset?.asposproductid || "";
        }
        // Check if element exists and is visible
        if (skuElement && !skuElement.closest(".visually-hide")) {
            productSku = skuElement.textContent.trim();
        }
        if (/^[0-9]+$/.test(productSku)) {
            productSku = productSku.padStart(10, '0');
        } else {
            productSku = "";
        }
         await productShelfLocationAPI(productSku, asposProductID);
    }

    const productDetailsKluslistSection = document.querySelector(".product-media-gallery-wrap");
    if(productDetailsKluslistSection) {
        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';
        await kluslistProductDetailPageAPI(cid);
    }
});

// ── Recommendations loaded handler ──────────────────────────────────────────
// product-recommendations.js dispatches "recommendations:loaded" after it
// injects the fetched card HTML. Run inventoryAPI() so the new cards get
// real stock — replacing the inline "no-stock" placeholder — and so the
// add-to-cart button gets disabled/enabled correctly. Also refresh the
// wishlist (kluslist) ribbon state for those cards.
// ── FIX: Show loader while fetching stock for recommendation carousel cards.
document.addEventListener("recommendations:loaded", async () => {
    try {
        await inventoryAPI();

        const cid = window.ShopifyTranslations.customerId || '';
        if (cid) {
            await kluslistProductCardAPI(cid);
        }
    } catch (error) {
        console.error("recommendations:loaded error:", error);
    }
});

function updateCartSelectedStoreUI(store = null) {
    let _fallbackName = '';
    if (!store) {
        try {
            const _saved = JSON.parse(localStorage.getItem('bm_preferred_store'));
            _fallbackName = _saved?.locationName || '';
        } catch (e) { console.warn('[Store] Failed to parse bm_preferred_store:', e); }
        if (!_fallbackName) {
            _fallbackName = localStorage.getItem('storeName') ||
                            window.ShopifyTranslations?.selectStoreName || '';
        }
    }
    const selectedStoreName =
        store?.locationName ||
        store?.storeName ||
        _fallbackName;

    const deliveryHeadingTarget = document.querySelector(".js-cart-selected-store");
    const storeLink = document.querySelector(".delivery-link.js-open-store-selector");

    if (deliveryHeadingTarget) {
        deliveryHeadingTarget.textContent = selectedStoreName
            ? `Pick up in ${selectedStoreName}`
            : "Pick a Store";
    }

    if (storeLink) {
        storeLink.textContent = selectedStoreName
            ? "Wijzig vestiging"
            : "Afhalen";
    }
}

function getLanguageWithDelay(timeoutMs = 1000) {
    return new Promise((resolve) => {
        const html = document.documentElement;
        const isTranslated = () =>
        html.classList.contains('translated-ltr') || html.classList.contains('translated-rtl');
        const readLang = () => (html.lang ? html.lang.split('-')[0] : null);
        // Translation widget already finished before we even checked — trust it now.
        if (isTranslated()) {
            resolve(readLang() || 'nl');
            return;
        }
        const observer = new MutationObserver(() => {
            if (isTranslated()) {
                clearTimeout(timer);
                observer.disconnect();
                resolve(readLang() || 'nl');
            }
        });
        observer.observe(html, { attributes: true, attributeFilter: ['lang', 'class'] });
        // No translation happened (page really is nl, or widget never fired) — use whatever lang is now.
        const timer = setTimeout(() => {
            observer.disconnect();
            resolve(readLang() || 'nl');
        }, timeoutMs);
    });
}

async function productShelfLocationAPI(productSku, asposProductID) {
    const loader = '<svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#000933"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/></path></g></g></svg>';
    document.querySelector(".display-product-shelf-locaton").innerHTML = `<div class="display-product-shelf-locaton-loader">${loader} <span>${window.ShopifyTranslations.productShelfLocationLoading}</span></div>`;
    const selectedStoreID = parseInt(window.ShopifyTranslations.selectStoreID);
    const productShelfLocationRegexs = window.ShopifyTranslations.productShelfLocationRegex;
    const productShelfLocationRegexsList = productShelfLocationRegexs.split("|").map(r => r.trim());
    const productShelfLocationRegex = productShelfLocationRegexsList[0];
    const productShelfLocationStringRegex = productShelfLocationRegexsList[1];

    const language = await getLanguageWithDelay(1000);
    console.log("Language-", language);
    if(selectedStoreID > 0) {
        if(((productSku && productSku !== "" && productSku.length > 0) || (asposProductID && asposProductID !== "" && asposProductID.length > 0)) && language && language !== ""){
            await fetch('/apps/apis/api/product/product_shelf', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({data:btoa(JSON.stringify({storeID: `${selectedStoreID}`, asposProductID: asposProductID, asposScancodeID: productSku, productShelfLocationRegex: productShelfLocationRegex, productShelfLocationStringRegex: productShelfLocationStringRegex, lang: language}))})
            })
            .then(async res => {
                if(res.ok){
                    const response = await res.json();
                    const decodedString = atob(response.result);
                    const reponseData = JSON.parse(decodedString);
                    if(reponseData.status) {
                        const shelfLocation = reponseData.locationText;
                        let locationStack = "";
                        const results = shelfLocation.split(" - ").map(slot => slot.split(" "));
                        locationStack += "<ul>";
                        results.forEach(result => {
                            locationStack += `<li><span>${result[0]}</span><span>${result[1]}</span></li>`;
                        });
                        locationStack += "</ul>";
                        document.querySelector(".display-product-shelf-locaton").innerHTML = locationStack;
                    } else {
                        document.querySelector(".display-product-shelf-locaton").innerHTML = `<p>${reponseData.message}</p>`;
                    }
                } else {
                    document.querySelector(".display-product-shelf-locaton").innerHTML = `<p>${reponseData.message}</p>`;
                }
            })
            .catch(err => {
                document.querySelector(".display-product-shelf-locaton").innerHTML = `<p>${window.ShopifyTranslations.productShelfLocationError}</p>`;
            });
        } else {
            document.querySelector(".display-product-shelf-locaton").innerHTML = `<p>${window.ShopifyTranslations.productShelfLocationError}</p>`;
        }
    } else {
        document.querySelector(".display-product-shelf-locaton").innerHTML = `<p>${window.ShopifyTranslations.productShelfLocationStoreNotFound}</p>`;
    }
}

let __inventoryAPIQueue = Promise.resolve();

async function inventoryAPI() {
    __inventoryAPIQueue = __inventoryAPIQueue.then(() => runInventoryAPI());
    return __inventoryAPIQueue;
}

async function runInventoryAPI() {
    const selectedStoreID = getSelectedStockStoreID();
    const lowInventoryThreshold = parseInt(window.ShopifyTranslations.lowInventoryThreshold);
    const hasSelectedStore = selectedStoreID !== "";

    const newCards = document.querySelectorAll(".load-more-new-card");

    const productCards = newCards.length
        ? newCards
        : document.querySelectorAll(".card-product:not(.inventory-loaded)");

    if (!productCards.length) return;

    const cards = Array.from(productCards).filter(card => {
        const stockCard = card.querySelector(".product-stock-availablity-card");
        const sku = stockCard?.dataset?.productsku;
        return sku && /^[0-9]+$/.test(sku);
    });

    if (!cards.length) return;

    const BATCH_SIZE = 50;

    for (let i = 0; i < cards.length; i += BATCH_SIZE) {
        const batchCards = cards.slice(i, i + BATCH_SIZE);

        const skus = [...new Set(
            batchCards.map(card => {
                const stockCard = card.querySelector(".product-stock-availablity-card");
                return stockCard.dataset.productsku.padStart(10, "0");
            })
        )];

        if (!skus.length) continue;

        const stockAvailability = await stockApi(skus.join(","));

        if (!stockAvailability || !stockAvailability.length) {
            continue;
        }

        batchCards.forEach(productCard => {
            const productStockCard = productCard.querySelector(".product-stock-availablity-card");
            if (!productStockCard) return;

            let productSku = productStockCard.dataset.productsku;
            if (!/^[0-9]+$/.test(productSku)) return;

            productSku = productSku.padStart(10, "0");

            const productStock = stockAvailability.find(
                p => parseInt(p.productNumber) === parseInt(productSku)
            );

            if (!productStock) return;

            let onlineStoreStock = parseInt(productStock?.homeDeliveryStock || 0);
            if (onlineStoreStock <= 0) onlineStoreStock = 0;

            let pickStoreStock = 0;

            if (hasSelectedStore) {
                pickStoreStock = parseInt(
                    productStock?.pickUpStock?.find(
                        p => String(p.storeId) === selectedStoreID
                    )?.availableQuantity || 0
                );

                if (pickStoreStock <= 0) pickStoreStock = 0;
            }

            let storeStockClass = "no-stock";
            let pickupStockClass = "no-stock";

            if (onlineStoreStock > 0 && onlineStoreStock < lowInventoryThreshold) {
                storeStockClass = "in-stock";
            } else if (onlineStoreStock >= lowInventoryThreshold) {
                storeStockClass = "large-stock";
            }

            if (pickStoreStock > 0 && pickStoreStock < lowInventoryThreshold) {
                pickupStockClass = "in-stock";
            } else if (pickStoreStock >= lowInventoryThreshold) {
                pickupStockClass = "large-stock";
            }

            productStockCard.innerHTML = `
                <div class="availability-item ${storeStockClass}">
                    <span class="dot"></span>
                    <span class="label">${window.ShopifyTranslations.onlineStoreLabel}</span>
                </div>
                <div class="availability-item ${pickupStockClass}">
                    <span class="dot"></span>
                    <span class="label">${window.ShopifyTranslations.pickupStoreLabel}</span>
                </div>
            `;

            const addToCartButton = productCard.querySelector(".button-add-to-cart");

            if (addToCartButton) {
                const isVariantUnavailable =
                    addToCartButton.dataset.variantUnavailable === "true";

                if (onlineStoreStock <= 0 && pickStoreStock <= 0) {
                    addToCartButton.disabled = true;
                } else if (!isVariantUnavailable) {
                    addToCartButton.disabled = false;
                }
            }

            productCard.classList.add("inventory-loaded");
            productCard.classList.remove("load-more-new-card");
        });
    }
}

async function productInventoryApi(productSku) {
    const selectedStoreID = getSelectedStockStoreID();
    let lowInventoryThreshold = window.ShopifyTranslations.lowInventoryThreshold;
    lowInventoryThreshold = parseInt(lowInventoryThreshold);
    
    const onlineStoreStockCard = document.querySelector(".online-store-inventory");
    const pickupStoreStockCard = document.querySelector(".pickup-store-inventory");

    let storeStockClass = "unavailable";
    let pickupStockClass = "unavailable";
    let storeStockText = window.ShopifyTranslations.onlineStoreQtyUnavailableText;
    let pickupStockText = window.ShopifyTranslations.pickupStoreQtyUnavailableText;

    if(onlineStoreStockCard) {
        onlineStoreStockCard.innerHTML = `<span class="status-pill ${storeStockClass}">0</span> ${storeStockText}`;
    }
    if(pickupStoreStockCard) {
        pickupStoreStockCard.innerHTML = `<span class="status-pill ${pickupStockClass}">0</span> ${pickupStockText}`;
    }
            
    const stockAvailability = await stockApi(productSku);

    // FIX: removed `&& selectedStoreID > 0` from the outer guard.
    // The /apps/apis/stock response carries homeDeliveryStock (online) which
    // does NOT depend on a selected store. Previously the whole block was
    // skipped when no store was picked, so online stock stayed at the "0 /
    // unavailable" placeholder until a store was selected AND the page
    // refreshed. Pickup stock still depends on a store and is guarded below.
    const hasSelectedStore = selectedStoreID !== "";

    //Check if response is available
    if(stockAvailability && stockAvailability.length > 0) {
        const productStock = stockAvailability.find(p => parseInt(p.productNumber) === parseInt(productSku));
        if(productStock) {
            let onlineStoreStock = productStock?.homeDeliveryStock || 0;
            onlineStoreStock = parseInt(onlineStoreStock);
            if(onlineStoreStock <= 0){ onlineStoreStock = 0; }

            let onlineStoreStockMax = productStock?.homeDeliveryMaxStockDefault || 0;
            onlineStoreStockMax = parseInt(onlineStoreStockMax);
            if(onlineStoreStockMax <= 0){ onlineStoreStockMax = 0; }

            // FIX: only resolve pickup stock when a store is actually selected.
            // With no store, pickup stays 0 / red (expected behaviour).
            let pickStoreStock = 0;
            if (hasSelectedStore) {
                pickStoreStock = productStock?.pickUpStock?.find(p => String(p.storeId) === selectedStoreID)?.availableQuantity || 0;
                pickStoreStock = parseInt(pickStoreStock);
                if(pickStoreStock <= 0){ pickStoreStock = 0; }
            }

            _currentPickStoreStock = pickStoreStock;

            // Update delivery/pickup card messages using real pickup stock
            renderPdpDeliveryMessage(pickStoreStock, onlineStoreStock, onlineStoreStockMax);
            
            //Online Store — store-independent, always evaluated
            if(parseInt(onlineStoreStock) > 0 && parseInt(onlineStoreStock) < parseInt(lowInventoryThreshold)) {
                storeStockClass = "in-stock";
                storeStockText = window.ShopifyTranslations.onlineStoreQtyAvailableText;
            } else if(parseInt(onlineStoreStock) > 0 && parseInt(onlineStoreStock) >= parseInt(lowInventoryThreshold)) {
                storeStockClass = "available";
                storeStockText = window.ShopifyTranslations.onlineStoreQtyAvailableText;
            }

            //Pickup Stores — only meaningful when a store is selected
            if(hasSelectedStore) {
                if(parseInt(pickStoreStock) > 0 && parseInt(pickStoreStock) < parseInt(lowInventoryThreshold)) {
                    pickupStockClass = "in-stock";
                    pickupStockText = window.ShopifyTranslations.pickupStoreQtyAvailableText;
                } else if(parseInt(pickStoreStock) > 0 && parseInt(pickStoreStock) >= parseInt(lowInventoryThreshold)) {
                    pickupStockClass = "available";
                    pickupStockText = window.ShopifyTranslations.pickupStoreQtyAvailableText;
                }
            }

            if(onlineStoreStockCard) {
                onlineStoreStockCard.innerHTML = `<span class="status-pill ${storeStockClass}">${onlineStoreStock}</span> ${storeStockText}`;
            }
            if(pickupStoreStockCard) {
                // FIX: show "-" when no store is selected instead of 0, so the UI
                // clearly communicates that pickup stock is unknown until a store is picked.
                // When a store IS selected, show the real stock value (including 0).
                const pickupStockDisplay = hasSelectedStore ? pickStoreStock : "-";
                pickupStoreStockCard.innerHTML = `<span class="status-pill ${pickupStockClass}">${pickupStockDisplay}</span> ${pickupStockText}`;
            }

            // Enable/disable PDP add to cart button based on stock availability
            const pdpAddToCartButton = document.querySelector('[data_testid="pdp-add-tocart-btn"]');
            if (pdpAddToCartButton) {
                // Don't enable if variant is unavailable at Shopify level
                const isVariantUnavailable = pdpAddToCartButton.dataset.variantUnavailable === "true";
                if (onlineStoreStock <= 0 && pickStoreStock <= 0) {
                    pdpAddToCartButton.disabled = true;
                } else if (!isVariantUnavailable) {
                    pdpAddToCartButton.disabled = false;
                }
            }

            // Set global stock value so QuantityInput.checkBackorderNotice() in global.js can access it
            _currentOnlineStoreStock = onlineStoreStock;
            _currentOnlineStoreStockMax = onlineStoreStockMax;
            console.log('[Inventory] _currentOnlineStoreStock set to:', _currentOnlineStoreStock);
            console.log('[Inventory] _currentOnlineStoreStockMax set to:', _currentOnlineStoreStockMax);

            // Set max on PDP quantity input (online stock as default — no delivery method on PDP)
            const pdpQtyInput = document.querySelector('.product-block-product-form .quantity-input-field');
            if (pdpQtyInput) {
                // TEMP: disabled max enforcement on the input so users can type any value freely.
                // The add-to-cart button still gets disabled below if qty > stock.
                // if (onlineStoreStock > 0) {
                //     pdpQtyInput.max = onlineStoreStock;
                // } else {
                //     pdpQtyInput.removeAttribute('max');
                // }

                // Stash latest stock on the input so the listener always reads fresh values
                // (productInventoryApi can be re-run on store change)
                pdpQtyInput.dataset.onlineStock = onlineStoreStock;
                pdpQtyInput.dataset.pickupStock = pickStoreStock;

                // const qtyEl = pdpQtyInput.closest('quantity-input');
                // if (qtyEl && typeof qtyEl.validateQtyRules === 'function') {
                //     qtyEl.validateQtyRules();
                // }

                // Disable add-to-cart if requested qty exceeds available stock
                const enforcePdpQtyMax = () => {
                    const btn = document.querySelector('[data_testid="pdp-add-tocart-btn"]');
                    if (!btn) return;
                    // Respect Shopify-level unavailability — never re-enable in that case
                    if (btn.dataset.variantUnavailable === 'true') {
                        btn.disabled = true;
                        return;
                    }

                    const onlineStock = parseInt(pdpQtyInput.dataset.onlineStock, 10) || 0;
                    const pickupStock = parseInt(pdpQtyInput.dataset.pickupStock, 10) || 0;
                    const currentQty  = parseInt(pdpQtyInput.value, 10) || 0;

                    // Validate against whichever stock pool is highest (online vs pickup)
                    const relevantStock = Math.max(onlineStock, pickupStock);

                    const exceedsStock = relevantStock > 0 && currentQty > relevantStock;
                    const noStockAtAll = onlineStock <= 0 && pickupStock <= 0;

                    btn.disabled = exceedsStock || noStockAtAll;
                };

                // Initial sync
                enforcePdpQtyMax();

                // Bind once — guard against duplicate listeners on store-change re-runs
                if (!pdpQtyInput.dataset.maxEnforceBound) {
                    pdpQtyInput.addEventListener('input', enforcePdpQtyMax);
                    pdpQtyInput.addEventListener('change', enforcePdpQtyMax);
                    pdpQtyInput.dataset.maxEnforceBound = 'true';
                }

                // Re-render delivery message live when qty changes (qty > max switches rule)
                if (!pdpQtyInput.dataset.deliveryMsgBound) {
                    pdpQtyInput.dataset.deliveryMsgBound = 'true';
                    const rerender = () => renderPdpDeliveryMessage(
                        _currentPickStoreStock,
                        _currentOnlineStoreStock,
                        _currentOnlineStoreStockMax
                    );
                    pdpQtyInput.addEventListener('input',  rerender);
                    pdpQtyInput.addEventListener('change', rerender);
                }
            }

            // for Backorder Form
            // ── Show/hide backorder notice based on real stock values ────
            updateBackorderNotice(onlineStoreStock, pickStoreStock);
        }
    }
}

// Page-lifetime cache of cart stock keyed by numeric SKU. Cart stock is fetched
// ONCE per page load (and once for a genuinely new SKU, e.g. an added item).
// Delivery-method switches, quantity changes and store changes re-render the
// rows but re-apply stock FROM THIS CACHE instead of calling the stock API again.
const __cartStockCache = new Map();

async function cartProductInventoryAPI(){
    const cartProductCards = document.querySelectorAll(".cart-item");
    if (!cartProductCards.length) return;

    // SKUs currently in the cart.
    const allSkus = Array.from(cartProductCards)
        .map(cartProductCard => (cartProductCard ? cartProductCard.dataset.productsku : null))
        .filter(Boolean)
        .filter(sku => /^[0-9]+$/.test(sku))
        .map(sku => sku.padStart(10, '0'));

    //Donot make a call for Stock API
    if (!allSkus.length) return;

    // Fetch ONLY SKUs not already cached — all of them on first load, just a
    // newly added item otherwise. Nothing is fetched on delivery-method /
    // quantity / store changes because those SKUs are already cached.
    const missing = allSkus.filter(sku => !__cartStockCache.has(parseInt(sku, 10)));
    if (missing.length) {
        const stockAvailability = await stockApi(missing.join(","));
        if (stockAvailability && stockAvailability.length > 0) {
            stockAvailability.forEach(p => {
                __cartStockCache.set(parseInt(p.productNumber), p);
            });
        }
    }

    applyCartStockFromCache(cartProductCards);
}

// Render the cart stock columns + write the per-row stock data attributes from
// the page-lifetime cache. Runs on every trigger (load, re-render, store change)
// so the dataset that delivery-date / quantity-max validation reads is always
// restored after a section re-render — with NO network call.
function applyCartStockFromCache(cartProductCards){
    cartProductCards = cartProductCards || document.querySelectorAll(".cart-item");

    const selectedStoreID = getSelectedStockStoreID();
    let lowInventoryThreshold = window.ShopifyTranslations.lowInventoryThreshold;
    lowInventoryThreshold = parseInt(lowInventoryThreshold);

    const selectedStoreName = localStorage.getItem("storeName") || window.ShopifyTranslations.selectStoreName || "";
    let cartOnlineStoreText = window.ShopifyTranslations.cartOnlineStoreText;
    let cartPickupStoreText = selectedStoreName
        ? `In ${selectedStoreName}`
        : window.ShopifyTranslations.cartPickupStoreText;

    // FIX: removed `&& selectedStoreID > 0` from the outer guard so the cart
    // online-stock column renders before a store is picked. Pickup column is
    // guarded separately below.
    const hasSelectedStore = selectedStoreID !== "";

    let appliedAny = false;
    cartProductCards.forEach(cartProductCard => {
        let productSku = cartProductCard.dataset.productsku;
        if (!/^[0-9]+$/.test(productSku)) return;
        const productStock = __cartStockCache.get(parseInt(productSku, 10));
        if(productStock) {
            appliedAny = true;
            let onlineStoreStock = productStock?.homeDeliveryStock || 0;
            onlineStoreStock = parseInt(onlineStoreStock);
            if(onlineStoreStock <= 0) { onlineStoreStock = 0; }

            let onlineStoreStockMax = productStock?.homeDeliveryMaxStockDefault || 0;
            onlineStoreStockMax = parseInt(onlineStoreStockMax);
            if(onlineStoreStockMax <= 0) { onlineStoreStockMax = 0; }

            // FIX: only resolve pickup stock when a store is selected.
            let pickStoreStock = 0;
            if (hasSelectedStore) {
                pickStoreStock = productStock?.pickUpStock?.find(p => String(p.storeId) === selectedStoreID)?.availableQuantity || 0;
                pickStoreStock = parseInt(pickStoreStock);
                if(pickStoreStock <= 0) { pickStoreStock = 0; }
            }

            let storeStockClass = "unavailable";
            let pickupStockClass = "unavailable";

            //Online Store
            if(parseInt(onlineStoreStock) > 0 && parseInt(onlineStoreStock) < parseInt(lowInventoryThreshold)) {
                storeStockClass = "in-stock";
            } else if(parseInt(onlineStoreStock) > 0 && parseInt(onlineStoreStock) >= parseInt(lowInventoryThreshold)) {
                storeStockClass = "available";
            }

            //Pickup Stores — only when a store is selected
            if(hasSelectedStore) {
                if(parseInt(pickStoreStock) > 0 && parseInt(pickStoreStock) < parseInt(lowInventoryThreshold)) {
                    pickupStockClass = "in-stock";
                } else if(parseInt(pickStoreStock) > 0 && parseInt(pickStoreStock) >= parseInt(lowInventoryThreshold)) {
                    pickupStockClass = "available";
                }
            }

            const onlineStoreStockCard = cartProductCard.querySelector(".store-stock-wrapper");
            const pickupStoreStockCard = cartProductCard.querySelector(".pick-store-stock-wrapper");

            if(onlineStoreStockCard) {
                onlineStoreStockCard.innerHTML = `<span class="cart-stock ${storeStockClass}">${onlineStoreStock}</span><span class="cart-stock-text">${cartOnlineStoreText}</span>`;
            }

            if(pickupStoreStockCard) {
                // FIX: show "-" when no store is selected instead of 0, so the UI
                // clearly communicates that pickup stock is unknown until a store is picked.
                // When a store IS selected, show the real stock value (including 0).
                const pickupStockDisplay = hasSelectedStore ? pickStoreStock : "-";
                pickupStoreStockCard.innerHTML = `<span class="cart-stock ${pickupStockClass}">${pickupStockDisplay}</span><span class="cart-stock-text">${cartPickupStoreText}</span>`;
            }

            // Store stock values as data attributes for quantity max enforcement
            cartProductCard.dataset.onlineStock = onlineStoreStock;
            cartProductCard.dataset.onlineStockMax = onlineStoreStockMax;
            cartProductCard.dataset.pickupStock = pickStoreStock;

        }
    });

    if (appliedAny) {
        // Dispatch custom event to notify that cart inventory has been updated
        document.dispatchEvent(new CustomEvent('cart:inventory:updated'));
        applyCartQuantityMax();
    }
}

// Re-run inventory API after cart sections are re-rendered (e.g. after pallet add/remove)
document.addEventListener('cart:sections:updated', async function() {
    const cartProductCards = document.querySelectorAll('.cart-item');
    if (cartProductCards.length > 0) {
        await cartProductInventoryAPI();
    }
});

function applyCartQuantityMax() {
    const selectedRadio = document.querySelector('input[name="delivery_option"]:checked');
    const isPickup = selectedRadio ? selectedRadio.value === 'Store-Pickup' : false;

    document.querySelectorAll('.cart-item').forEach(function(cartItem) {
        const stock = parseInt(isPickup ? cartItem.dataset.pickupStock : cartItem.dataset.onlineStock, 10) || 0;

        // Cart row has TWO quantity inputs (mobile + desktop) — sync BOTH
        cartItem.querySelectorAll('.quantity-input-field').forEach(function(input) {
            if (stock > 0) {
                input.max = stock;
            } else {
                input.removeAttribute('max');
            }
            const qtyEl = input.closest('quantity-input');
            if (qtyEl && typeof qtyEl.validateQtyRules === 'function') {
                qtyEl.validateQtyRules();
            }
        });
    });
}

// Re-apply quantity max when delivery method changes on the cart page
document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="delivery_option"]')) {
        applyCartQuantityMax();
        applyMiniCartQuantityMax();
    }
});

// ── Mini-cart stock max enforcement ──────────────────────────────────────────
// Mirrors cartProductInventoryAPI()/applyCartQuantityMax() for .mini-cart-item
// rows, sharing the same page-lifetime __cartStockCache.
async function miniCartProductInventoryAPI() {
    const miniCartItems = document.querySelectorAll(".mini-cart-item");
    if (!miniCartItems.length) return;

    const allSkus = Array.from(miniCartItems)
        .map(item => item.dataset.productsku)
        .filter(Boolean)
        .filter(sku => /^[0-9]+$/.test(sku))
        .map(sku => sku.padStart(10, "0"));

    if (!allSkus.length) return;

    const missing = allSkus.filter(sku => !__cartStockCache.has(parseInt(sku, 10)));
    if (missing.length) {
        const stockAvailability = await stockApi(missing.join(","));
        if (stockAvailability && stockAvailability.length > 0) {
            stockAvailability.forEach(p => {
                __cartStockCache.set(parseInt(p.productNumber), p);
            });
        }
    }

    applyMiniCartQuantityMax();
}

// Cap follows the cart-page delivery radio when present; otherwise (no method
// chosen yet) the larger of the online/pickup pools, like the PDP rule.
function applyMiniCartQuantityMax() {
    const selectedStoreID = getSelectedStockStoreID();
    const hasSelectedStore = selectedStoreID !== "";
    const selectedRadio = document.querySelector('input[name="delivery_option"]:checked');

    document.querySelectorAll(".mini-cart-item").forEach(function(miniCartItem) {
        const productSku = miniCartItem.dataset.productsku;
        if (!productSku || !/^[0-9]+$/.test(productSku)) return;
        const productStock = __cartStockCache.get(parseInt(productSku, 10));
        if (!productStock) return;

        let onlineStoreStock = parseInt(productStock?.homeDeliveryStock || 0, 10);
        if (onlineStoreStock <= 0) { onlineStoreStock = 0; }

        let pickStoreStock = 0;
        if (hasSelectedStore) {
            pickStoreStock = parseInt(productStock?.pickUpStock?.find(p => String(p.storeId) === selectedStoreID)?.availableQuantity || 0, 10);
            if (pickStoreStock <= 0) { pickStoreStock = 0; }
        }

        miniCartItem.dataset.onlineStock = onlineStoreStock;
        miniCartItem.dataset.pickupStock = pickStoreStock;

        const stock = selectedRadio
            ? (selectedRadio.value === 'Store-Pickup' ? pickStoreStock : onlineStoreStock)
            : Math.max(onlineStoreStock, pickStoreStock);

        miniCartItem.querySelectorAll('.quantity-input-field').forEach(function(input) {
            if (stock > 0) {
                input.max = stock;
            } else {
                input.removeAttribute('max');
            }
            const qtyEl = input.closest('quantity-input');
            if (qtyEl && typeof qtyEl.validateQtyRules === 'function') {
                qtyEl.validateQtyRules();
            }
        });
    });
}

document.addEventListener('cart-drawer:open', function() {
    miniCartProductInventoryAPI();
});

// fires after product-form re-renders the mini-cart contents
document.addEventListener('cart:item-add', function() {
    miniCartProductInventoryAPI();
});

// Mini-cart checkout: ensure delivery-method is set before proceeding to checkout
document.addEventListener('click', async function(e) {
    const checkoutBtn = e.target.closest('button[name="checkout"]');
    if (!checkoutBtn || !checkoutBtn.closest('.mini-cart-footer-actions')) return;
    e.preventDefault();
    const cid = window.ShopifyTranslations.customerId || '';
    const cart = await window.CartStore.get();
    if (!cart.attributes || !cart.attributes['delivery-method']) {
        const _cartFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
        await _cartFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'delivery-method': 'Shipping' } })
        });
    }
    if(cid) {
        window.location.href = '/checkout';
    } else {
        window.location.href = `${window.ShopifyTranslations.loginPageUrl}`;
    }
});

async function stockApi(skusParam) {
    // Batch all stock lookups requested within a short window into ONE
    // /apps/apis/stock request, then serve repeat lookups for the same SKU set
    // from a short-TTL cache. Several triggers (the delivery switch,
    // cart:sections:updated, store:selected) re-request stock for the SAME cart
    // SKUs within a couple of seconds — caching eliminates those redundant
    // network calls. The response is store-independent (pickUpStock carries
    // every store, the caller filters by store OID), so caching by SKU is safe
    // across store changes. Each caller filters the response by productNumber,
    // so receiving the merged superset is transparent.
    if (!skusParam) return;

    if (!__stockApiBatch) {
        const batch = { skus: new Set(), promise: null, resolve: null };
        batch.promise = new Promise(function (resolve) { batch.resolve = resolve; });
        __stockApiBatch = batch;
        setTimeout(function () {
            __stockApiBatch = null;
            batch.resolve(_cachedStockRequest([...batch.skus].join(",")));
            // Wishlist ribbons refresh on every lookup (even cache hits) so
            // re-rendered cart rows always get fresh state.
            _refreshKluslistRibbons();
        }, STOCK_API_BATCH_MS);
    }

    String(skusParam).split(",").forEach(function (sku) {
        sku = sku.trim();
        if (sku) __stockApiBatch.skus.add(sku);
    });

    return __stockApiBatch.promise;
}

// Coalesces concurrent stockApi() callers into a single network request.
let __stockApiBatch = null;
const STOCK_API_BATCH_MS = 50;

// Short-TTL response cache keyed by the (sorted) SKU set. Caches the PROMISE so
// concurrent identical requests also de-dup against an in-flight fetch. Kept
// short so genuine stock changes are still picked up.
const STOCK_CACHE_TTL_MS = 4000;
const __stockResponseCache = new Map();

function _cachedStockRequest(skusParam) {
    const key = String(skusParam)
        .split(",")
        .map(function (s) { return s.trim(); })
        .filter(Boolean)
        .sort()
        .join(",");
    if (!key) return Promise.resolve();

    const now = Date.now();
    const hit = __stockResponseCache.get(key);
    if (hit && hit.expires > now) {
        return hit.promise;
    }

    const promise = _stockApiRequest(key);
    __stockResponseCache.set(key, { promise: promise, expires: now + STOCK_CACHE_TTL_MS });
    // Don't keep failed/empty responses cached — let the next lookup retry.
    promise.then(function (result) {
        if (!result || !result.length) {
            const cur = __stockResponseCache.get(key);
            if (cur && cur.promise === promise) __stockResponseCache.delete(key);
        }
    });
    return promise;
}

// Refresh wishlist (kluslist) ribbons. Pulled out of the stock fetch so it runs
// on every stock lookup, including cache hits.
function _refreshKluslistRibbons() {
    const cid = window.ShopifyTranslations.customerId || '';
    if (cid) {
        kluslistCartProductCardAPI("desktop", cid);
        kluslistCartProductCardAPI("mobile", cid);
    }
}

// Reload the page once when the stock endpoint stays rate-limited (CartQueue's
// own retries already ran and still got 429), so cards don't sit with a wrong
// "no stock" signal. sessionStorage-guarded: at most one auto-reload per 30s,
// preventing a reload loop while the rate limit persists.
function _stock429Reload() {
    try {
        const KEY = '_stock429ReloadAt';
        const last = Number(sessionStorage.getItem(KEY) || 0);
        if (Date.now() - last < 30000) return;
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
    } catch (e) { /* sessionStorage unavailable — skip auto-reload */ }
}

async function _stockApiRequest(skusParam) {
    if (!skusParam) return;
    try {
        const skus = String(skusParam).split(",").map(s => s.trim()).filter(Boolean);
        const _stockFetch = (window.CartQueue ? window.CartQueue.fetch : fetch);
        const BATCH_SIZE = 50;
        const batches = [];
        for (let i = 0; i < skus.length; i += BATCH_SIZE) {
            batches.push(skus.slice(i, i + BATCH_SIZE));
        }
        console.log(`stock calling — ${skus.length} SKUs in ${batches.length} batch(es)`);
        const batchResults = await Promise.all(batches.map(async function (batch) {
            const batchParam = batch.join(",");
            const response = await _stockFetch(`/apps/apis/stock?productNumbers=${batchParam}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.status === 429) {
                _stock429Reload();
                return [];
            }
            if (!response.ok) return [];
            const data = await response.json();
            console.log('response in product', data);
            return Array.isArray(data) ? data : [];
        }));
        return batchResults.flat();
    } catch (error) {
        return;
    }
}

// ── Backorder notice show/hide ───────────────────────────────────────────────
// Called by productInventoryApi() with the real stock values.
// Conditions to show:
//   1. data-backorder-show-backorder="true"  (customer eligible + block enabled, set by Liquid)
//   2. Both onlineStoreStock AND pickStoreStock are <= 0 (out of stock per external API)
function updateBackorderNotice(onlineStoreStock, pickStoreStock = 0) {
    const wrapper = document.querySelector('.product-backorder-wrapper');
    if (!wrapper) return;

    const shouldShow   = wrapper.dataset.backorderShowBackorder === 'true';
    const isOutOfStock = parseInt(onlineStoreStock) <= 0 && parseInt(pickStoreStock) <= 0;

    console.log(`[Backorder Notice] shouldShow: ${shouldShow}, isOutOfStock: ${isOutOfStock}, onlineStoreStock: ${onlineStoreStock}, pickStoreStock: ${pickStoreStock}`);

    // Show backorder wrapper only if customer is eligible AND product is out of stock
    wrapper.style.display = (shouldShow && isOutOfStock) ? 'block' : 'none';
}

const waitForCompare = () => new Promise(resolve => {
    const productCompare = document.querySelector("product-compare");
    const grid = document.querySelector(".product-compare-grid");

    if (!productCompare || !grid) {
        resolve();
        return;
    }

    // If already loaded and has products, resolve immediately
    if (productCompare.classList.contains('is-loaded')) {
        const products = grid.querySelectorAll(".product-compare-product");
        const expectedCount = parseInt(getComputedStyle(grid).getPropertyValue('--compare-product-count')) || products.length;
        if (products.length >= expectedCount && expectedCount > 0) {
            resolve();
            return;
        }
    }

    // Watch for DOM changes on the grid (products being appended)
    // AND class changes on product-compare (is-loaded being added)
    const observer = new MutationObserver(() => {
        if (!productCompare.classList.contains('is-loaded')) return;

        const products = grid.querySelectorAll(".product-compare-product");
        const expectedCount = parseInt(getComputedStyle(grid).getPropertyValue('--compare-product-count')) || 0;

        if (products.length > 0 && products.length >= expectedCount) {
            observer.disconnect();
            resolve();
        }
    });

    observer.observe(productCompare, { attributes: true, attributeFilter: ['class'] });
    observer.observe(grid, { childList: true, subtree: false });
});

async function compareInventoryAPI() {
    const compareProducts = document.querySelectorAll(".product-compare-product");
    const selectedStoreID = getSelectedStockStoreID();
    let lowInventoryThreshold = parseInt(window.ShopifyTranslations.lowInventoryThreshold);

    let productSkus = Array.from(compareProducts).map(item => {
        const stockCard = item.querySelector(".product-stock-availablity-card");
        return stockCard ? stockCard.dataset.productsku : null;
    }).filter(Boolean)
      .filter(sku => /^[0-9]+$/.test(sku))
      .map(sku => sku.padStart(10, '0'));

    if (!productSkus.length) return;

    productSkus = [...new Set(productSkus)];
    const skusParam = productSkus.join(",");

    const stockAvailability = await stockApi(skusParam);

    // FIX: removed `|| selectedStoreID <= 0` from the early-return so online
    // stock dots render on the compare page before a store is selected.
    // Pickup dots are guarded separately below.
    if (!stockAvailability || !stockAvailability.length) return;

    const hasSelectedStore = selectedStoreID !== "";

    compareProducts.forEach(item => {
        const productStockCard = item.querySelector(".product-stock-availablity-card");
        if (!productStockCard) return;

        let productSku = productStockCard.dataset.productsku;
        if (!/^[0-9]+$/.test(productSku)) return;

        const paddedSku = productSku.padStart(10, '0');
        const productStock = stockAvailability.find(p =>
            parseInt(p.productNumber) === parseInt(paddedSku)
        );

        if (!productStock) return;

        let onlineStoreStock = Math.max(0, parseInt(productStock?.homeDeliveryStock || 0));

        // FIX: only resolve pickup stock when a store is selected.
        let pickStoreStock = 0;
        if (hasSelectedStore) {
            pickStoreStock = Math.max(0, parseInt(
                productStock?.pickUpStock?.find(p =>
                    String(p.storeId) === selectedStoreID
                )?.availableQuantity || 0
            ));
        }

        let storeStockClass = "no-stock";
        let pickupStockClass = "no-stock";

        if (onlineStoreStock > 0 && onlineStoreStock < lowInventoryThreshold) {
            storeStockClass = "in-stock";
        } else if (onlineStoreStock >= lowInventoryThreshold) {
            storeStockClass = "large-stock";
        }

        if (pickStoreStock > 0 && pickStoreStock < lowInventoryThreshold) {
            pickupStockClass = "in-stock";
        } else if (pickStoreStock >= lowInventoryThreshold) {
            pickupStockClass = "large-stock";
        }

        productStockCard.innerHTML = `
            <div class="availability-item ${storeStockClass}">
                <span class="dot"></span>
                <span class="label">${window.ShopifyTranslations.onlineStoreLabel}</span>
            </div>
            <div class="availability-item ${pickupStockClass}">
                <span class="dot"></span>
                <span class="label">${window.ShopifyTranslations.pickupStoreLabel}</span>
            </div>`;

        // Enable/disable add to cart button based on stock availability
        const addToCartButton = item.querySelector(".button-add-to-cart");
        if (addToCartButton) {
            // Don't enable if variant is unavailable at Shopify level
            const isVariantUnavailable = addToCartButton.dataset.variantUnavailable === "true";
            if (onlineStoreStock <= 0 && pickStoreStock <= 0) {
                addToCartButton.disabled = true;
            } else if (!isVariantUnavailable) {
                addToCartButton.disabled = false;
            }
        }
    });
}

document.querySelectorAll('select[name^="options["]').forEach(select => {
    select.addEventListener('change', async (e) => {
        const changedSelect = e.target;
        const selectedValue = changedSelect.value;
        const display = changedSelect.closest('variant-selects')?.querySelector('.variant-card__display .variant-card__value');
        if (display) {
            display.innerText = selectedValue;
        }
    });
});

function showToast(message, type = "success") {
    const referenceEl = document.getElementById("kluslist-main-wrapper");
    if (!referenceEl) return;

    let container = document.getElementById("toast-container");
    if (!container) {
        container = document.createElement("div");
        container.id = "toast-container";
        container.className = "toast-container";
    }

    const toast = document.createElement("div");
    toast.className = `toast toast-${type}`;
    toast.innerText = message;
    toast.style.borderLeft = "4px solid transparent";
    if (type === "success") {
        toast.style.background = "#D8F3EA";
        toast.style.borderColor = "#237659";
    }
    if (type === "error") {
        toast.style.background = "#FBD0D0";
        toast.style.borderColor = "#E91616";
    }
    container.appendChild(toast);

    setTimeout(() => {
        toast.remove();
    }, 3000);
}

// Only apply download handler to buttons in the document section
document.querySelectorAll("[id^='custom-download-document-services-'] .custom_bm_cta_button").forEach((btn) => {
    btn.addEventListener("click", function (e) {
        e.preventDefault();
        const originalHTML = this.innerHTML;
        this.innerHTML = "DOWNLOADING...";
        const url = this.getAttribute("href");
        fetch(url)
        .then(res => res.blob())
        .then(blob => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = url.split("/").pop().split("?")[0];
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.innerHTML = originalHTML;
        })
        .catch(() => {
            this.innerHTML = originalHTML;
        });
    });
});

// kluslist Ids for Already avaiable products
const selectedKluslistIds = new Set();
// Store selected IDs
const selectedIds = new Set();

function getWishlistSkuFromButton(button) {
    const directSku = button?.dataset?.productSku || button?.dataset?.productsku || "";
    if (directSku) return directSku.trim();

    const cardSku = button?.closest(".card-product")?.querySelector("[data-card-sku]")?.textContent || "";
    if (cardSku) return cardSku.trim();

    const cartSku = button?.closest(".cart-item")?.dataset?.productsku || button?.closest(".cart-item")?.dataset?.productSku || "";
    return cartSku ? cartSku.trim() : "";
}

function createWishlistProductPayload(sku, quantity = 1) {
    if (!sku) return null;

    return {
        sku: String(sku).trim(),
        quantity: quantity || 1
    };
}

function createWishlistAvailabilityPayload(sku) {
    if (!sku) return null;

    return {
        sku: String(sku).trim()
    };
}

async function fetchCustomerKluslist(sku="", variationId="", source="", productIdsArray=[], kluslistButton=null, isRemovedFromCart) {
    const cid = window.ShopifyTranslations.customerId || '';
    const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';
    if(cid) {
        const payload = {
            customerId: `${cid}`
        }
        if(source === "producttile" && sku && sku !== "") {
            payload.sku = sku
        }
        await fetch('/apps/apis/api/customer/wishlist/fetch?perPageItem=300', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(async res => {
            if(res.ok){
                const response = await res.json();
                if(response.status) {
                    const kluslistResponse = response.response || [];
                    if(kluslistResponse.length >= 0) {
                        let isDisabled = kluslistResponse.length <= 0 ? "disabled" : "";

                        let kluslistHtml = "";
                        kluslistHtml += `<div class="kluslist-main-inner-wrapper">
                            <div class="kluslist-main-primary-header-wrapper"><div><h2>New to-do list</h2></div><div><button class="close-kluslist-sidebar"><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M0.7025 8.87167L0 8.16917L3.73333 4.43583L0 0.7025L0.7025 0L4.43583 3.73333L8.16917 0L8.87167 0.7025L5.13833 4.43583L8.87167 8.16917L8.16917 8.87167L4.43583 5.13833L0.7025 8.87167Z" fill="#000933"></path></svg></button></div></div>
                            <div class="kluslist-main-secondary-header-wrapper">
                                <div style="display:flex">
                                    <label class="select-all-label">
                                        <input type="checkbox" id="selectAll" ${isDisabled} />
                                        <span></span>
                                    </label>
                                    <span class="klabel">Select all to-do lists</span>
                                </div>
                                <div style="text-align: right; justify-content: end; display: grid;">
                                    <button type="button" id="add-product-kluslist">
                                        <span>NEW TO-DO LIST</span>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 15" fill="none">
                                                <path d="M6.45833 14.1667V7.70833H0V6.45833H6.45833V0H7.70833V6.45833H14.1667V7.70833H7.70833V14.1667H6.45833Z" fill="#0A55D7"/>
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div class="kluslist-main-center-wrapper">
                                <ul id="wishlistContainer">`;
                                    if(kluslistResponse.length > 0) {
                                        kluslistResponse.forEach((result, index) => {
                                            const isPresent = result.isPresent;
                                            const isChecked = isPresent ? "checked" : "";
                                            
                                            kluslistHtml += `<li>
                                                <div>
                                                    <label>
                                                        <input type="checkbox" class="itemCheckbox" value="${result._id}" ${isChecked} />
                                                        <span></span>
                                                    </label>
                                                    <div>
                                                        <h5>${result.wishlistName}</h5>
                                                        <div><span>${result.productCount} ITEMS</span></div>
                                                    </div>
                                                </div>
                                            </li>`;

                                            if(isPresent) {
                                                selectedKluslistIds.add(result._id);
                                                selectedIds.add(result._id);
                                            }
                                        });
                                    }
                kluslistHtml += `</ul>
                            </div>
                            <div class="kluslist-main-footer-wrapper">
                                <button type="button" id="add-kluslist" class="add-kluslist" data-pdetails='${JSON.stringify(productIdsArray)}' data-isremoved="${isRemovedFromCart}">
                                    <span>ADD TO KLUSLIST</span>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 15" fill="none">
                                            <path d="M6.45833 14.1667V7.70833H0V6.45833H6.45833V0H7.70833V6.45833H14.1667V7.70833H7.70833V14.1667H6.45833Z" fill="#C1CFD7"/>
                                        </svg>
                                    </span>
                                </button>    
                            </div>
                        </div>`;
                        document.getElementById("kluslist-main-wrapper").innerHTML = kluslistHtml;

                        if(kluslistResponse.length > 0) {
                            const checkboxes = document.querySelectorAll('#wishlistContainer .itemCheckbox');
                            checkboxes.forEach(cb => {
                                const li = cb.closest('li');

                                if (cb.checked) {
                                    selectedIds.add(cb.value);
                                    li?.classList.add('selected-kluslist');
                                } else {
                                    selectedIds.delete(cb.value);
                                    li?.classList.remove('selected-kluslist');
                                }
                            });
                            updateSelectAllState();
                        }
                    }
                }
            }
            if(kluslistButton) {
                if (kluslistButton.classList.contains("kluslist-loader")) {
                    kluslistButton.classList.remove("kluslist-loader");
                }
            }
        })
        .catch(error => {
            if(kluslistButton) {
                if (kluslistButton.classList.contains("kluslist-loader")) {
                    kluslistButton.classList.remove("kluslist-loader");
                }
            }
            showToast(`${error}`, "error");
        });
    } else {
        if(kluslistButton) {
            if (kluslistButton.classList.contains("kluslist-loader")) {
                kluslistButton.classList.remove("kluslist-loader");
            }
        }
    }
}

document.addEventListener('change', (e) => {

    if (e.target.classList.contains('itemCheckbox')) {
        const checkbox = e.target;
        const li = checkbox.closest('li');
        if (checkbox.checked) {
            selectedIds.add(checkbox.value);
            li?.classList.add('selected-kluslist');
        } else {
            selectedIds.delete(checkbox.value);
            li?.classList.remove('selected-kluslist');
        }
        updateSelectAllState();
    }

    if (e.target.id === 'selectAll') {
        const selectAll = e.target;
        const checkboxes = document.querySelectorAll('#wishlistContainer .itemCheckbox');

        selectedIds.clear();

        checkboxes.forEach(cb => {
            cb.checked = selectAll.checked;
            const li = cb.closest('li');

            if (selectAll.checked) {
                selectedIds.add(cb.value);
                li?.classList.add('selected-kluslist');
            } else {
                li?.classList.remove('selected-kluslist');
            }
        });
    }

    const isSelectionSame = selectedKluslistIds.size === selectedIds.size && [...selectedKluslistIds].every(id => selectedIds.has(id)) && [...selectedIds].every(id => selectedKluslistIds.has(id));

    if((selectedIds.size > 0 || selectedIds.size <= 0) && !isSelectionSame) {
        document.querySelector("#add-kluslist")?.classList?.add("active");
    } else {
        document.querySelector("#add-kluslist")?.classList?.remove("active");
    }
});

function updateSelectAllState() {
    const selectAll = document.getElementById('selectAll');
    const label = selectAll.closest("label");
    const checkboxes = document.querySelectorAll('#wishlistContainer .itemCheckbox');

    if (!selectAll || checkboxes.length === 0) return;

    const allChecked = [...checkboxes].every(cb => cb.checked);
    const noneChecked = [...checkboxes].every(cb => !cb.checked);

    if (allChecked) {
        selectAll.checked = true;
        selectAll.indeterminate = false;
        label.classList.remove("indeterminate");
    } 
    else if (noneChecked) {
        selectAll.checked = false;
        selectAll.indeterminate = false;
        label.classList.remove("indeterminate");
    } 
    else {
        selectAll.checked = false;
        selectAll.indeterminate = true;
        label.classList.add("indeterminate");
    }
}

document.addEventListener("click", async function (e) {
    //It will open a panel to enter the Kluslist Name
    if (e.target.closest("#add-product-kluslist")) {
        const container = document.getElementById("wishlistContainer");
        if (document.querySelector(".add-new-kluslist-contaiiner")) return;
        container.insertAdjacentHTML("beforebegin", `
            <div class="add-new-kluslist-contaiiner">
                <div class="add-new-kluslist-inner-contaiiner">
                    <div>
                        <label for="todolistname">New to-do list</label>
                        <input type="text" name="todolistname" id="todolistname" className="todolistname" placeholder="Enter new to-do list name"/>
                    </div>
                    <div style="display: flex; justify-content: end;">
                        <button type="button" id="proceed-with-new-kluslist">
                            <span>CREATE LIST</span>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                                    <path d="M10.1058 6.875H0V5.625H10.1058L5.35896 0.878126L6.25 0L12.5 6.25L6.25 12.5L5.35896 11.6219L10.1058 6.875Z" fill="white"/>
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        `);
    }

    //Proceed with API To add a New Kluslist
    if (e.target.closest("#proceed-with-new-kluslist")) {
        const btn = e.target.closest("#proceed-with-new-kluslist");
        const originalHTML = btn.innerHTML;

        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';

        const input = document.getElementById("todolistname");
        const value = input?.value || "";
        const kluslisttitle = value.replace(/[^\p{L}0-9 ]/gu, "").trim();

        if(kluslisttitle.length > 0) {
            input.classList.remove("input-error");
            if(cid) {
                const mainWrapper = document.querySelector(".kluslist-main-wrapper");
                if (mainWrapper) {
                    mainWrapper.classList.add("kluslist-main-loader-wrapper");
                }
                btn.innerHTML = `<span>Processing...</span>`;
                btn.disabled = true;
                await fetch('/apps/apis/api/customer/wishlist/create', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        customerId: `${cid}`,
                        wishlistName: kluslisttitle
                    })
                }).then(async res => {
                    input.classList.remove("input-error");
                    if(res.ok){
                        const response = await res.json();
                        if(response.status) {
                            const kluslistMainContainer = document?.getElementById("wishlistContainer");
                            if(kluslistMainContainer) {
                                const newKluslist = `
                                    <li>
                                        <div>
                                            <label>
                                                <input type="checkbox" class="itemCheckbox" value="${response.wishlistId}" />
                                                <span></span>
                                            </label>
                                            <div>
                                                <h5>${response.wishlistTitle}</h5>
                                                <div><span>0 ITEMS</span></div>
                                            </div>
                                        </div>
                                    </li>
                                `;
                                kluslistMainContainer.insertAdjacentHTML("afterbegin", newKluslist);
                                document.querySelector('.kluslist-main-secondary-header-wrapper > div:first-child input').disabled = false;
                            }
                            document.querySelector(".add-new-kluslist-contaiiner")?.remove();
                            showToast(`${response.message}`, "success");
                        } else {
                            showToast(`${response.message}`, "error");
                        }
                        btn.innerHTML = originalHTML;
                        btn.disabled = false;
                        input.value = "";
                        if (mainWrapper) {
                            mainWrapper.classList.remove("kluslist-main-loader-wrapper");
                        }
                    } else {
                        btn.innerHTML = originalHTML;
                        btn.disabled = false;
                        input.value = "";
                        if (mainWrapper) {
                            mainWrapper.classList.remove("kluslist-main-loader-wrapper");
                        }
                        showToast(`${res.statusText}`, "error");
                    }
                })
                .catch(error => {
                    btn.innerHTML = originalHTML;
                    btn.disabled = false;
                    input.value = "";
                    if (mainWrapper) {
                        mainWrapper.classList.remove("kluslist-main-loader-wrapper");
                    }
                    showToast(`${error}`, "error");
                });
            } else {
                window.location.href = window.ShopifyTranslations.loginPageUrl;
            }
        } else {
            input.classList.add("input-error");
        }
    }

    //Close the side of Kluslist
    if(e.target.closest(".close-kluslist-sidebar")) {
        document.getElementById("kluslist-main-wrapper").innerHTML = "";
        selectedIds.clear();
        selectedKluslistIds.clear();
    }

    //Add specifc product to the kluslist
    if(e.target.closest("#add-kluslist")) {
        const btn = e.target.closest("#add-kluslist");
        const originalHTML = btn.innerHTML;

        //Difference of kluslist which customer select manually - selectedIds and kluslist where product is already present - selectedKluslistIds 
        const removedFromKluslist = new Set([...selectedKluslistIds].filter(id => !selectedIds.has(id)));

        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';

        if(cid) {
            if((Array.from(selectedIds).length > 0 || Array.from(removedFromKluslist).length > 0)) {
                const productsArray = JSON.parse(btn.dataset.pdetails);
                const isremoved = btn.dataset.isremoved;
        
                btn.innerHTML = `<span>Processing...</span>`;
                btn.disabled = true;

                const mainWrapper = document.querySelector(".kluslist-main-wrapper");
                if (mainWrapper) {
                    mainWrapper.classList.add("kluslist-main-loader-wrapper");
                }

                const isNewElementExists = [...selectedIds, ...removedFromKluslist].filter( item => !selectedKluslistIds.has(item) );
                const addProductPayload = {
                    customerId: `${cid}`,
                    productsArray: productsArray,
                    idsArray: Array.from(selectedIds)
                };

                if (removedFromKluslist.size > 0) {
                    addProductPayload.removedFromKluslist = Array.from(removedFromKluslist);
                }
                
                await fetch('/apps/apis/api/customer/wishlist/add-product', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(addProductPayload)
                }).then(async res => {
                    if(res.ok){
                        const response = await res.json();
                        if(response.status) {
                            // GTM: add_to_job
                            try {
                                const _gtmProducts = JSON.parse(btn.dataset.pdetails);
                                window.dataLayer = window.dataLayer || [];
                                [...selectedIds].forEach(jobId => {
                                    const _cb = document.querySelector(`#wishlistContainer .itemCheckbox[value="${jobId}"]`);
                                    const _jobName = _cb?.closest('li')?.querySelector('h5')?.textContent?.trim() || '';
                                    _gtmProducts.forEach(product => {
                                        window.dataLayer.push({
                                            event: 'add_to_job',
                                            item_id: product.sku || (product.productId || '').replace('gid://shopify/Product/', ''),
                                            item_name: product.productTitle || '',
                                            job_id: jobId,
                                            job_name: _jobName,
                                            page_type: window.bm_page_type || ''
                                        });
                                    });
                                });
                            } catch (_e) {}
                            showToast(`${response.message}`, "success");
                            await kluslistProductCardAPI(cid);
                            if(window.location.pathname === "/cart") {
                                await kluslistCartProductCardAPI("desktop", cid);
                                await kluslistCartProductCardAPI("mobile", cid);
                            } else {
                                await kluslistProductDetailPageAPI(cid);
                            }
                            // if(isremoved === "yes" && isNewElementExists.length > 0) {
                            //     try {
                            //         const cart = await fetch('/cart.js').then(res => res.json());
                            //         if(cart?.items?.length && productsArray?.length) {
                            //             const variantIds = productsArray.map(p =>Number(p.variationId.split("/").pop()));
                            //             const itemsToRemove = cart.items.filter(item => variantIds.includes(item.variant_id));
                            //             if (itemsToRemove.length > 0) {
                            //                 if(variantIds.length > 1) {
                            //                     await fetch('/cart/clear.js', {
                            //                         method: 'POST',
                            //                         headers: {
                            //                             'Content-Type': 'application/json',
                            //                         },
                            //                     }).then(() => {
                            //                         window.location.reload();
                            //                     });
                            //                 } else {
                            //                     removeCartItemByVariationId(`${productsArray[0]['productId'].replace("gid://shopify/Product/", "")}-${productsArray[0]['variationId'].replace("gid://shopify/ProductVariant/", "")}`);
                            //                 }
                            //             }
                            //         }
                            //     } catch (error) {}
                            // }
                        } else {
                            showToast(`${response.message}`, "error");
                        }
                        btn.innerHTML = originalHTML;
                        btn.disabled = false;
                        if (mainWrapper) {
                            mainWrapper.classList.remove("kluslist-main-loader-wrapper");
                        }
                        document.getElementById("kluslist-main-wrapper").innerHTML = "";
                        selectedIds.clear();
                        selectedKluslistIds.clear();
                    } else {
                        btn.innerHTML = originalHTML;
                        btn.disabled = false;
                        if (mainWrapper) {
                            mainWrapper.classList.remove("kluslist-main-loader-wrapper");
                        }
                        document.getElementById("kluslist-main-wrapper").innerHTML = "";
                        selectedIds.clear();
                        selectedKluslistIds.clear();
                        showToast(`${res.statusText}`, "error");
                    }
                })
                .catch(error => {
                    btn.innerHTML = originalHTML;
                    btn.disabled = false;
                    if (mainWrapper) {
                        mainWrapper.classList.remove("kluslist-main-loader-wrapper");
                    }
                    document.getElementById("kluslist-main-wrapper").innerHTML = "";
                    selectedIds.clear();
                    selectedKluslistIds.clear();
                    showToast(`${error}`, "error");
                });
            }
        } else {
            window.location.href = window.ShopifyTranslations.loginPageUrl;
        }
    }

    //Add all cart products to kluslist
    if (e.target.closest("#add-all-cart-kluslist")) {
        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';

        const cardDataMap = new Map();
        const seen = new Set();
        const productsArray = [];

        const cartProductCards = document.querySelectorAll(".cart-item");
        
        if(cid) {
            if(cartProductCards.length > 0) {
                const prefix = "add-desktop-cart-variation-kluslist-";
                
                for (const cartProductCard of cartProductCards) {
                    const btn = cartProductCard.querySelector(`[class*='${prefix}']`);
                    if (!btn) continue;

                    const targetClass = [...btn.classList].find(c => c.startsWith(prefix));
                    if (!targetClass) continue;

                    const [, , , , , pId, vId] = targetClass.split("-");
                    if (!pId || !vId) continue;

                    const sku = getWishlistSkuFromButton(btn);
                    if (!sku) continue;

                    const key = sku;

                    if (seen.has(key)) continue;
                    seen.add(key);

                    const qtyInput = cartProductCard.querySelector('.quantity-input input');
                    const qtyValue = qtyInput ? parseInt(qtyInput.value, 10) : 1;

                    cardDataMap.set(key, { btn, sku });
                    productsArray.push(createWishlistProductPayload(sku, qtyValue));
                }
                
                if(productsArray.length > 0) {
                    const kluslistButton = e.target.closest("#add-all-cart-kluslist");
                    if(kluslistButton){
                        kluslistButton.classList.add("kluslist-loader");
                    }
                    const productIdsArray = productsArray;
                    await fetchCustomerKluslist("", "", "", productIdsArray, kluslistButton, "yes");
                }
            }
        } else {
            window.location.href = window.ShopifyTranslations.loginPageUrl;
        }
    }
});

document.addEventListener("input", function (e) {
    if (e.target && e.target.id === "todolistname") {
        e.target.value = e.target.value.replace(/[^\p{L}0-9 ]/gu, "");
        if (e.target.classList.contains("input-error")) {
            e.target.classList.remove("input-error");
        }
    }
});

document.addEventListener("click", function (e) {
    const kluslistButton = e.target.closest("[class*='add-variation-kluslist-']");
    if (!kluslistButton) return;

    kluslistButton.classList.add("kluslist-loader");
    
    const targetClass = [...kluslistButton.classList].find(cls =>
        cls.startsWith("add-variation-kluslist-")
    );
    if (!targetClass) {kluslistButton.classList.remove("kluslist-loader");return};

    const quantity = 1;

    const parts = targetClass.split("-");
    const pId = parts[3];
    const vId = parts[4];

    // GTM: add_to_favorites
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'add_to_favorites',
        item_id: pId,
        item_name: kluslistButton.dataset.productTitle || '',
        page_type: window.bm_page_type || ''
    });

    extractProductDetail(pId, vId, quantity, kluslistButton, "");
});

document.addEventListener("click", function (e) {
    const kluslistButton = e.target.closest("[class*='add-pdp-variation-kluslist-']");
    if (!kluslistButton) return;

    kluslistButton.classList.add("kluslist-loader");

    const targetClass = [...kluslistButton.classList].find(cls =>
        cls.startsWith("add-pdp-variation-kluslist-")
    );
    if (!targetClass) {kluslistButton.classList.remove("kluslist-loader");return};

    const qtyInput = kluslistButton.closest('div.product-page').querySelector('div.product-qty-size input.quantity-input-field');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    
    const parts = targetClass.split("-");
    const pId = parts[4];
    const vId = parts[5];

    extractProductDetail(pId, vId, quantity, kluslistButton, "");
});

document.addEventListener("click", function (e) {
    const kluslistButton = e.target.closest("[class*='add-desktop-cart-variation-kluslist-']");
    if (!kluslistButton) return;

    e.preventDefault();

    kluslistButton.classList.add("kluslist-loader");

    const targetClass = [...kluslistButton.classList].find(cls =>
        cls.startsWith("add-desktop-cart-variation-kluslist-")
    );
    if (!targetClass) {kluslistButton.classList.remove("kluslist-loader");return};

    const qtyInput = kluslistButton.closest('tr.cart-item').querySelector('input.quantity-input-field');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    const parts = targetClass.split("-");
    const pId = parts[5];
    const vId = parts[6];
    
    extractProductDetail(pId, vId, quantity, kluslistButton, "yes");
});

document.addEventListener("click", function (e) {
    const kluslistButton = e.target.closest("[class*='add-mobile-cart-variation-kluslist-']");
    if (!kluslistButton) return;
    
    e.preventDefault();

    kluslistButton.classList.add("kluslist-loader");

    const targetClass = [...kluslistButton.classList].find(cls =>
        cls.startsWith("add-mobile-cart-variation-kluslist-")
    );
    if (!targetClass) {kluslistButton.classList.remove("kluslist-loader");return};

    const qtyInput = kluslistButton.closest('tr.cart-item').querySelector('input.quantity-input-field');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    const parts = targetClass.split("-");
    const pId = parts[5];
    const vId = parts[6];
    
    extractProductDetail(pId, vId, quantity, kluslistButton, "yes");
});

function extractProductDetail(pId, vId, quantity, kluslistButton=null, isRemovedFromCart) {
    if(pId && pId !== "" && vId && vId !== "" && Number.isFinite(Number(pId)) && Number.isFinite(Number(vId))) {
        const cid = window.ShopifyTranslations.customerId || '';
        const myAccountDomainUri = window.ShopifyTranslations.myAccountDomainUri || '';
        if(cid) {
            const sku = getWishlistSkuFromButton(kluslistButton);
            const productPayload = createWishlistProductPayload(sku, quantity || 1);
            if (!productPayload) {
                if(kluslistButton?.classList.contains("kluslist-loader")) {
                    kluslistButton.classList.remove("kluslist-loader");
                }
                return;
            }

            fetchCustomerKluslist(sku, "", "producttile", [productPayload], kluslistButton, isRemovedFromCart);
        } else {
            if(kluslistButton) {
                if (kluslistButton.classList.contains("kluslist-loader")) {
                    kluslistButton.classList.remove("kluslist-loader");
                }
            }
            window.location.href = window.ShopifyTranslations.loginPageUrl;
        }
    } else {
        if(kluslistButton) {
            if (kluslistButton.classList.contains("kluslist-loader")) {
                kluslistButton.classList.remove("kluslist-loader");
            }
        }
    }
}

async function productAvailabilityApi(cid, productsArray) {
    try {
        const response = await fetch(
            '/apps/apis/api/customer/wishlist/fetch-products-avaibility',
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ customerId: String(cid), productsArray })
            }
        );

        if (!response.ok) return;

        const { products = [] } = await response.json();
        return products;
    } catch {}
    return [];
}

const ribbonSVG = {
    default: `<svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.33325 27V4.66663H24.6666V27L15.9999 23.2776L7.33325 27ZM9.33325 23.9333L15.9999 21.0666L22.6666 23.9333V6.66663H9.33325V23.9333Z" fill="#0A55D7"/></svg>`,
    active:  `<svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.33325 27V4.66663H24.6666V27L15.9999 23.2776L7.33325 27Z" fill="#0A55D7"/></svg>`,
    cartFavDefault: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0A55D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-heart"> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"></path> </svg>`,
    cartFavActive: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0A55D7" stroke="#0A55D7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-heart"> <path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"></path> </svg>`,
};

//API Call is For Product Tile to check the product availability in wishlist
async function kluslistProductCardAPI(cid) {
    const cardDataMap = new Map();
    const seen = new Set();
    const productsArray = [];

    const productCards = document.querySelectorAll(".card-product, .requirements-product");

    if(cid && productCards.length > 0) {
        for (const card of productCards) {
            const btn = card.querySelector("[class*='add-variation-kluslist-']");
            if (!btn) continue;

            const targetClass = [...btn.classList].find(c => c.startsWith("add-variation-kluslist-"));
            if (!targetClass) continue;

            const [, , , pId, vId] = targetClass.split("-");
            if (!pId || !vId) continue;

            const sku = getWishlistSkuFromButton(btn);
            if (!sku) continue;

            const key = sku;

            if (seen.has(key)) continue;
            seen.add(key);

            cardDataMap.set(key, { btn, sku });
            productsArray.push(createWishlistAvailabilityPayload(sku));
        }

        if (productsArray.length > 0) {
            const products = await productAvailabilityApi(cid, productsArray);
            if (products.length > 0) {
                const presentSet = new Set(
                    products.filter(p => p.isPresent).map(p => p.sku)
                );

                for (const [key, { btn }] of cardDataMap) {
                    const isPresent = presentSet.has(key);
                    btn.classList.toggle("is-present", isPresent);
                    btn.innerHTML = isPresent ? ribbonSVG.active : ribbonSVG.default;
                }
            }
        }
    }
}

//API Call is For Product Detail Page
async function kluslistProductDetailPageAPI(cid) {
    const kluslistButton = document.querySelector("[class*='add-pdp-variation-kluslist-']");
    if(kluslistButton) {
        const targetClass = [...kluslistButton.classList].find(cls =>
            cls.startsWith("add-pdp-variation-kluslist-")
        );

        if(targetClass && cid) {
            const parts = targetClass.split("-");
            
            const pId = parts[4];
            const vId = parts[5];

            if(pId && pId !== "" && vId && vId !== "" && Number.isFinite(Number(pId)) && Number.isFinite(Number(vId))) {
                const sku = getWishlistSkuFromButton(kluslistButton);
                const productPayload = createWishlistAvailabilityPayload(sku);
                if (!productPayload) return;

                const products = await productAvailabilityApi(cid, [productPayload]);
                if (products.length > 0) {
                    const isPresent = products[0]?.isPresent || false;
                    if(isPresent) {
                        kluslistButton.innerHTML = isPresent ? ribbonSVG.active : ribbonSVG.default;
                    } else {
                        kluslistButton.innerHTML = ribbonSVG.default;
                    }
                }
            }
        }
    }
}

async function kluslistCartProductCardAPI(cartresource, cid) {
    const cardDataMap = new Map();
    const seen = new Set();
    const productsArray = [];

    const cartProductCards = document.querySelectorAll(".cart-item");
    
    if(cid && cartProductCards.length > 0) {
        const prefix = cartresource === "mobile" ? "add-mobile-cart-variation-kluslist-" : "add-desktop-cart-variation-kluslist-";
        
        for (const cartProductCard of cartProductCards) {
            const btn = cartProductCard.querySelector(`[class*='${prefix}']`);
            if (!btn) continue;

            const targetClass = [...btn.classList].find(c => c.startsWith(prefix));
            if (!targetClass) continue;

            const [, , , , , pId, vId] = targetClass.split("-");
            if (!pId || !vId) continue;

            const sku = getWishlistSkuFromButton(btn);
            if (!sku) continue;

            const key = sku;

            if (seen.has(key)) continue;
            seen.add(key);

            cardDataMap.set(key, { btn, sku });
            productsArray.push(createWishlistAvailabilityPayload(sku));
        }

        if (productsArray.length > 0) {
            const products = await productAvailabilityApi(cid, productsArray);
            
            if (products.length > 0) {
                const presentSet = new Set(
                    products.filter(p => p.isPresent).map(p => p.sku)
                );

                for (const [key, { btn }] of cardDataMap) {
                    const isPresent = presentSet.has(key);
                    btn.classList.toggle("is-present", isPresent);
                    if(cartresource === "desktop") {
                        const innerDiv = btn.querySelector("div");
                        if(innerDiv) {
                            innerDiv.innerHTML = isPresent ? ribbonSVG.active : ribbonSVG.default;
                        }
                    } else if (cartresource === "mobile") {
                        btn.innerHTML = isPresent ? ribbonSVG.active : ribbonSVG.default;
                    }
                }

                loadingCartKluslistAllButton((cartAllButton) => {
                    const hasFalse = products.some(item => item.isPresent === false);
                    if(cartAllButton) {
                        const buttonInnerDiv = cartAllButton.querySelector("div");
                        if(buttonInnerDiv){
                            buttonInnerDiv.innerHTML = hasFalse ? ribbonSVG.default : ribbonSVG.active;
                        }
                    }
                });
            }
        }
    }
}

function loadingCartKluslistAllButton(callback) {
  const observer = new MutationObserver(() => {
    const el = document.querySelector("#add-all-cart-kluslist");
    if (el) {
        observer.disconnect();
            callback(el);
        }
    });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function removeCartItemByVariationId(variationId) {
    const favButton = document.querySelector(
    `.add-desktop-cart-variation-kluslist-${variationId}`
    );

    if (!favButton) {
        return;
    }

    const cartItemRow = favButton.closest('.cart-item');

    if (!cartItemRow) {
        return;
    }

    const removeButton = cartItemRow.querySelector('.button-cart-remove');

    if (!removeButton) {
        return;
    }

    removeButton.click();
}

function clearErrorUI(input) {
    input.style.borderColor = "#C1CFD7";

    const errorEl = input.nextElementSibling;
    if (errorEl && errorEl.classList.contains("input-error")) {
        errorEl.remove();
    }
}

document.addEventListener("input", function (e) {
    const target = e.target;
    if (target.id === "quotationdate") {
        clearErrorUI(target);
    }
    if (target.id === "quotationemailaddress") {
        clearErrorUI(target);
    }
    if (target.id === "quotationphonenumber") {
        clearErrorUI(target);
        target.value = target.value.replace(/[^0-9+\s]/g, "");
        // keep only one +
        if ((target.value.match(/\+/g) || []).length > 1) {
            target.value = target.value.replace(/\+/g, "");
            target.value = "+" + target.value;
        }
    }
    if (e.target.id === "quotationmessage") {
        const max = 100;
        const currentLength = e.target.value.length;
        const counter = document.querySelector(".word-count-hint .current-count");
        if (counter) {
            counter.textContent = currentLength;
        }
        if (currentLength > max) {
            e.target.value = e.target.value.substring(0, max);
            counter.textContent = max;
        }
    }
});

document.addEventListener("click", async function (e) {
    if (e.target.closest(".quotation_event_button")) {
        const sidebar = document.querySelector(".quotation_event_main_sidebar_wrapper");
        if (sidebar) {
            sidebar.style.display = "block";
            document.body.style.overflow = "hidden";
        }
    }

    if(e.target.closest(".close-quotation-sidebar")) {
        const sidebar = document.querySelector(".quotation_event_main_sidebar_wrapper");
        if (sidebar) {
            sidebar.style.display = "none";
            document.body.style.overflow = "";
        }
        const date = document.getElementById("quotation_date");
        const email = document.getElementById("quotationemailaddress");
        const phone = document.getElementById("quotationphonenumber");
        const message = document.getElementById("quotationmessage");
        if (date) {
            date.value = "";
            const container = document.getElementById('quotation_date');
            const errorEl = container.parentElement.querySelector('.input-error');

            if (errorEl) {
                errorEl.remove();
            }
        }
        if (email) {
            email.value = "";
            clearErrorUI(email);
        }
        if (phone) {
            phone.value = "";
            clearErrorUI(phone);
        }
        if (message) {
            message.value = "";
        }
        const counter = document.querySelector(".word-count-hint .current-count");
        if (counter) counter.textContent = "0";
    }

    if (e.target.closest(".send_quotation_button")) {
        const button = e.target.closest(".send_quotation_button");
        const orderLines = button.dataset.orderlines ? JSON.parse(button.dataset.orderlines) : [];
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^(\+31|0031|31|0)(6[0-9]{8}|[1-9][0-9]{8})$/;

        let buttonOriginalHTML = button.innerHTML || "Send";

        const dateEl = document.getElementById("quotationdate");
        const emailEl = document.getElementById("quotationemailaddress");
        const phoneEl = document.getElementById("quotationphonenumber");
        const messageEl = document.getElementById("quotationmessage");

        const date = dateEl.value;
        const email = emailEl.value;
        const phone = phoneEl.value.replace(/[\s\-().]/g, '');
        const message = messageEl.value;

        function setError(input, message) {
            // input.style.borderColor = "#e91616";

            let errorEl = input.nextElementSibling;

            if (errorEl && errorEl.classList.contains("input-error")) {
                errorEl.textContent = message;
            } else {
                errorEl = document.createElement("span");
                errorEl.className = "input-error";
                errorEl.textContent = message;
                input.after(errorEl);
            }
        }

        function clearError(input) {
            input.style.borderColor = "#C1CFD7";

            const errorEl = input.nextElementSibling;
            if (errorEl && errorEl.classList.contains("input-error")) {
                errorEl.remove();
            }
        }

        let isValid = true;

        if (!date) {
            const dateEl1 = document.getElementById("quotation_date");
            setError(dateEl1, "Date is required");
            isValid = false;
        } else {
            const dateEl1 = document.getElementById("quotation_date");
            clearError(dateEl1);
        }

        const error = validateQuotationDate(dateEl.value);
        if (error) {
            const dateEl1 = document.getElementById("quotation_date");
            setError(dateEl1, error);
            isValid = false;
        } else {
            const dateEl1 = document.getElementById("quotation_date");
            clearError(dateEl1);
        }

        if (!email) {
            setError(emailEl, "Email is required");
            isValid = false;
        } else if (!emailRegex.test(email)) {
            setError(emailEl, "Enter a valid email");
            isValid = false;
        } else {
            clearError(emailEl);
        }

        if (!phone) {
            setError(phoneEl, "Phone number is required");
            isValid = false;
        } else if (!phoneRegex.test(phone)) {
            setError(phoneEl, "Enter a valid phone number");
            isValid = false;
        } else {
            clearError(phoneEl);
        }

        if (!isValid) return;
        try {
            const mainsidebar = document.querySelector(".quotation_event_main_inner_sidebar_wrapper");
            if(mainsidebar) {
                mainsidebar.classList.add("is-loading");
            }
            const cid = window.ShopifyTranslations.customerId || '';
            const customerStoreID = window.ShopifyTranslations.customerStoreId || '';

            const [day, month, year] = date.split("/");
            const payload = { 
                shopifyCustomerNumber: cid,
                storeId: customerStoreID,
                date: `${year}-${parseInt(month)}-${parseInt(day)}`,
                email: email,
                phoneNumber: phone,
                notes: message,
                orderLines: orderLines
            };

            console.log("payload:", payload);

            button.innerHTML = `<svg fill="#FFFFFF" class="loadersvg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="0"><animate begin="0;spinner_z0Or.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="0;3" fill="freeze"/><animate begin="spinner_OLMs.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="4;12" fill="freeze"/><animate begin="spinner_UHR2.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="12;20" fill="freeze"/><animate id="spinner_lo66" begin="spinner_Aguh.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0" fill="freeze"/><animate id="spinner_z0Or" begin="spinner_lo66.end" attributeName="cx" dur="0.001s" values="20;4" fill="freeze"/></circle><circle cx="4" cy="12" r="3"><animate begin="0;spinner_z0Or.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="4;12" fill="freeze"/><animate begin="spinner_OLMs.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="12;20" fill="freeze"/><animate id="spinner_JsnR" begin="spinner_UHR2.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0" fill="freeze"/><animate id="spinner_Aguh" begin="spinner_JsnR.end" attributeName="cx" dur="0.001s" values="20;4" fill="freeze"/><animate begin="spinner_Aguh.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="0;3" fill="freeze"/></circle><circle cx="12" cy="12" r="3"><animate begin="0;spinner_z0Or.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="12;20" fill="freeze"/><animate id="spinner_hSjk" begin="spinner_OLMs.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0" fill="freeze"/><animate id="spinner_UHR2" begin="spinner_hSjk.end" attributeName="cx" dur="0.001s" values="20;4" fill="freeze"/><animate begin="spinner_UHR2.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="0;3" fill="freeze"/></circle><circle cx="20" cy="12" r="3"><animate id="spinner_4v5M" begin="0;spinner_z0Or.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="3;0" fill="freeze"/><animate id="spinner_OLMs" begin="spinner_4v5M.end" attributeName="cx" dur="0.001s" values="20;4" fill="freeze"/><animate begin="spinner_OLMs.end" attributeName="r" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="0;3" fill="freeze"/><animate begin="spinner_UHR2.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="4;12" fill="freeze"/><animate begin="spinner_Aguh.end" attributeName="cx" calcMode="spline" dur="0.5s" keySplines=".36,.6,.31,1" values="12;20" fill="freeze"/></circle></svg>`;

            const response = await fetch(`/apps/apis/api/quotes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const responseData = await response.json();
                if(responseData.success) {
                    dateEl.value = "";
                    emailEl.value = "";
                    phoneEl.value = "";
                    messageEl.value = "";
                    const sidebar = document.querySelector(".quotation_event_main_sidebar_wrapper");
                    if (sidebar) {
                        sidebar.style.display = "none";
                    }
                    showToast(responseData?.message || "Quotation sent successfully", "success");
                } else {
                    showToast(responseData?.message || 'Failed to send quotation', "error");
                }
            } else {
                const responseData = await response.json();
                console.log("Error responseData", responseData);
                showToast(responseData?.message || 'Failed to send quotation', "error");
            }

            if(mainsidebar) {
                mainsidebar.classList.remove("is-loading");
            }
            button.innerHTML = buttonOriginalHTML;
            document.body.style.overflow = "";

        } catch (error) {
            if(mainsidebar) {
                mainsidebar.classList.remove("is-loading");
            }
            button.innerHTML = buttonOriginalHTML;
            document.body.style.overflow = "";
            showToast(`${error}`, "error");
        }
    }
});

function validateQuotationDate(str) {
    if (!str) return 'This field is required.';
    const date = parseDate(str);
    if (!date) {
        return 'Enter a valid date in DD/MM/YYYY format.';
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date < today) {
        return 'Past dates are not allowed.';
    }
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 30);
    maxDate.setHours(23, 59, 59, 999);
    if (date > maxDate) {
        return `Date must be on or before ${maxDate.toLocaleDateString('en-GB')}.`;
    }
    return '';
}

function parseDate(str) {
    const parts = str.split('/');
    if (parts.length !== 3) return null;
    const [day, month, year] = parts.map(Number);
    const date = new Date(year, month - 1, day);
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return null;
    }
    return date;
}

document.addEventListener("click", function (e) {
  const button = e.target.closest("#add-product-kluslist");
  if (!button) return;

  const container = document.querySelector(".kluslist-main-center-wrapper");
  if (!container) return;

  try {
    container.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  } catch (err) {
    container.scrollTop = 0;
  }
});

function resetCookies() {
    // Reuse CartStore's cached /cart.js (it already fetches once on every page
    // load) instead of firing a SEPARATE, un-queued GET /cart.json. That raw
    // request raced CartStore.refresh() + the stock API at load and contributed
    // to the edge bot-protection checkpoint (429). cart.js carries the same
    // item_count + token we need here, so no extra network request is made.
    const getCart = (window.CartStore && typeof window.CartStore.get === 'function')
      ? window.CartStore.get()
      : fetch('/cart.json').then(response => response.json());
    getCart.then(cart => {
        const rootDomain = '.bouwmaat.nl';
        if (cart.item_count === 0 || window.location.pathname.includes('/thank_you')) {
          document.cookie = `cart=; domain=${rootDomain}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure=true`;
        } 
        else if (cart.token) {
          const expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + 30);
          document.cookie = `cart=${cart.token}; domain=${rootDomain}; path=/; expires=${expiryDate.toUTCString()}; SameSite=None; Secure=true`;
        }
    }).catch(e => console.error('Cart sync error:', e));
}
resetCookies();


document.addEventListener("click", async function (e) {
    const loginPageUrl = window.ShopifyTranslations.loginPageUrl || '';
    
    //Desktop
    const accountBtn = e.target.closest("#customer-account-profile-desktop-button");
    const klusBtn = e.target.closest("#customer-account-kluslist-desktop-button");

    //Mobile
    const mobileAccountBtn = e.target.closest("#customer-account-profile-mobile-button");

    // GTM: click_username — logged-in user clicks their own name
    const usernameBtn = e.target.closest('[data-gtm-click-username]');
    if (usernameBtn) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'click_username',
            click_location: usernameBtn.dataset.gtmClickLocation || '',
            page_type: window.bm_page_type || '',
            page_location: window.location.href
        });
        return;
    }

    if (accountBtn || klusBtn || mobileAccountBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        // GTM: view_login
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'view_login',
            page_type: window.bm_page_type || '',
            login_location: accountBtn ? 'header' : 'header_wishlist'
        });
        const path = window.location.pathname;
        // window.location.href = `${/customer_authentication/login?return_to=${path}}`;
        window.location.href = `${loginPageUrl}`;
        return;
    }
});

// ── GTM: view_cart — fires when the mini-cart drawer is opened ───────────────
document.addEventListener('cart-drawer:open', function () {
  window.CartStore.get()
    .then(function (cart) {
      // Collapse whitespace + strip trailing punctuation from product names.
      var gtmCleanName = function (s) {
        return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(/[\s,;:]+$/, '').trim();
      };
      var items = (cart.items || []).map(function (item) {
        var varTitle = item.variant_title || '';
        var out = {
          item_id:       String(item.variant_id),
          item_name:     gtmCleanName(item.product_title || item.title),
          item_brand:    item.vendor || '',
          item_variant:  varTitle === 'Default Title' ? '' : varTitle,
          price:         item.final_price / 100,
          quantity:      item.quantity
        };
        // cart.js carries no breadcrumb metadata; fall back to product_type.
        if (item.product_type) out.item_category = item.product_type;
        return out;
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event:     'view_cart',
        cart_type: 'mini_cart',
        ecommerce: {
          currency: cart.currency,
          value:    cart.total_price / 100,
          items:    items
        }
      });
    })
    .catch(function () {});
});

// ── GTM: search — TODO: wire up when a keyword search input is added ─────────
// Add data-gtm-search-form to the <form> and data-gtm-search-input to the
// <input> element, then uncomment below.
//
// document.addEventListener('submit', function (e) {
//   var form = e.target.closest('[data-gtm-search-form]');
//   if (!form) return;
//   var input = form.querySelector('[data-gtm-search-input]');
//   if (!input || !input.value.trim()) return;
//   window.dataLayer = window.dataLayer || [];
//   window.dataLayer.push({
//     event:       'search',
//     search_term: input.value.trim(),
//     page_type:   window.bm_page_type || ''
//   });
// });
